// onetake · © 2026 Patrick (github.com/feitangyuan) · PolyForm Noncommercial 1.0.0 · lineage otk-7f3e1c
// Toee Tire uses this under its onetake Pro commercial licence (owner confirmed 2026-10-20). Do not edit; upgrade by re-vendoring.
"use strict";
(() => {
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };

  // assets/onetake-motion.js
  var require_onetake_motion = __commonJS({
    "assets/onetake-motion.js"(exports, module) {
      (function(root) {
        "use strict";
        const clamp = (v, a = 0, b = 1) => Math.max(a, Math.min(b, v));
        const lerp = (a, b, k) => a + (b - a) * k;
        const seg = (t, t0, t1) => t1 === t0 ? t >= t1 ? 1 : 0 : clamp((t - t0) / (t1 - t0), 0, 1);
        const sstep = (e0, e1, x) => {
          const k = clamp((x - e0) / (e1 - e0), 0, 1);
          return k * k * (3 - 2 * k);
        };
        const ssstep = (e0, e1, x) => {
          const k = clamp((x - e0) / (e1 - e0), 0, 1);
          return k * k * k * (k * (k * 6 - 15) + 10);
        };
        const powOut = (n) => (u) => 1 - Math.pow(1 - u, n);
        const powInOut = (n) => (u) => u < 0.5 ? Math.pow(2, n - 1) * Math.pow(u, n) : 1 - Math.pow(-2 * u + 2, n) / 2;
        const EXPO = 1 - Math.pow(2, -10);
        const ease = {
          linear: (u) => u,
          // t80 .80
          smooth: (u) => u * u * (3 - 2 * u),
          // t80 .71 smoothstep
          smoother: (u) => u * u * u * (u * (u * 6 - 15) + 10),
          // t80 .67 smootherstep — PW's travel curve
          sineInOut: (u) => -(Math.cos(Math.PI * u) - 1) / 2,
          cubicInOut: powInOut(3),
          // camera legs that start and stop at rest
          quintInOut: powInOut(5),
          quadOut: powOut(2),
          // t80 .55
          cubicOut: powOut(3),
          // t80 .42
          quartOut: powOut(4),
          // t80 .33
          quintOut: powOut(5),
          // t80 .28
          expoOut: (u) => u <= 0 ? 0 : u >= 1 ? 1 : (1 - Math.pow(2, -10 * u)) / EXPO,
          // t80 .23
          expoIn: (u) => u <= 0 ? 0 : u >= 1 ? 1 : (Math.pow(2, 10 * u) - 1) / 1023,
          expoInOut: (u) => u < 0.5 ? ease.expoIn(2 * u) / 2 : 1 - ease.expoIn(2 - 2 * u) / 2,
          // whips
          circOut: (u) => Math.sqrt(1 - Math.pow(1 - clamp(u), 2)),
          backOut: (u) => {
            const s = 1.70158;
            return 1 + (s + 1) * Math.pow(u - 1, 3) + s * Math.pow(u - 1, 2);
          },
          back: (s = 1.70158) => (u) => 1 + (s + 1) * Math.pow(u - 1, 3) + s * Math.pow(u - 1, 2)
        };
        function bezier(x1, y1, x2, y2) {
          const cx = 3 * x1, bx = 3 * (x2 - x1) - cx, ax = 1 - cx - bx, cy = 3 * y1, by = 3 * (y2 - y1) - cy, ay = 1 - cy - by;
          const sx = (s) => ((ax * s + bx) * s + cx) * s, sy = (s) => ((ay * s + by) * s + cy) * s, dsx = (s) => (3 * ax * s + 2 * bx) * s + cx;
          const solve = (x) => {
            let s = x;
            for (let i = 0; i < 8; i++) {
              const e = sx(s) - x;
              if (Math.abs(e) < 1e-7) return s;
              const d = dsx(s);
              if (Math.abs(d) < 1e-6) break;
              s -= e / d;
              if (s < 0 || s > 1) break;
            }
            let lo = 0, hi = 1;
            s = x;
            for (let i = 0; i < 60; i++) {
              const v = sx(s);
              if (Math.abs(v - x) < 1e-7) return s;
              if (x > v) lo = s;
              else hi = s;
              s = (lo + hi) / 2;
            }
            return s;
          };
          return (u) => u <= 0 ? 0 : u >= 1 ? 1 : sy(solve(u));
        }
        const tween = (t, t0, t1, curve = ease.expoOut) => curve(seg(t, t0, t1));
        function t80(curve, frac = 0.8, steps = 4e3) {
          for (let i = 0; i <= steps; i++) {
            const u = i / steps;
            if (curve(u) >= frac) return u;
          }
          return 1;
        }
        function spring(tau, zeta = 0.6, omega = 20) {
          if (tau <= 0) return 0;
          if (zeta < 1) {
            const wd = omega * Math.sqrt(1 - zeta * zeta);
            return 1 - Math.exp(-zeta * omega * tau) * (Math.cos(wd * tau) + zeta * omega / wd * Math.sin(wd * tau));
          }
          if (zeta === 1) return 1 - Math.exp(-omega * tau) * (1 + omega * tau);
          const q = omega * Math.sqrt(zeta * zeta - 1), r1 = -zeta * omega + q, r2 = -zeta * omega - q;
          return 1 - (r2 * Math.exp(r1 * tau) - r1 * Math.exp(r2 * tau)) / (r2 - r1);
        }
        function springVel(tau, zeta = 0.6, omega = 20) {
          if (tau <= 0) return 0;
          if (zeta < 1) {
            const s = Math.sqrt(1 - zeta * zeta);
            return omega / s * Math.exp(-zeta * omega * tau) * Math.sin(omega * s * tau);
          }
          if (zeta === 1) return omega * omega * tau * Math.exp(-omega * tau);
          const q = omega * Math.sqrt(zeta * zeta - 1), r1 = -zeta * omega + q, r2 = -zeta * omega - q;
          return omega * omega * (Math.exp(r1 * tau) - Math.exp(r2 * tau)) / (r1 - r2);
        }
        function ring(tau, decay = 9, omega = 26) {
          return tau <= 0 ? 0 : Math.exp(-decay * tau) * Math.sin(omega * tau);
        }
        function settle(zeta = 0.6, omega = 20, eps = 0.02) {
          let last = 0;
          for (let i = 1; i <= 2e4; i++) {
            const t = i / 1e3;
            if (Math.abs(1 - spring(t, zeta, omega)) > eps) last = t;
          }
          return last;
        }
        function spline(knots, t) {
          if (t <= knots[0].t) return [knots[0].x, knots[0].y];
          const L = knots.length;
          if (t >= knots[L - 1].t) return [knots[L - 1].x, knots[L - 1].y];
          let i = 0;
          while (knots[i + 1].t < t) i++;
          const k0 = knots[i], k1 = knots[i + 1], h = k1.t - k0.t, u = (t - k0.t) / h, km = knots[Math.max(0, i - 1)], kp = knots[Math.min(L - 1, i + 2)];
          const m0x = (k1.x - km.x) / (k1.t - km.t) * h, m0y = (k1.y - km.y) / (k1.t - km.t) * h, m1x = (kp.x - k0.x) / (kp.t - k0.t) * h, m1y = (kp.y - k0.y) / (kp.t - k0.t) * h;
          const h00 = 2 * u ** 3 - 3 * u ** 2 + 1, h10 = u ** 3 - 2 * u ** 2 + u, h01 = -2 * u ** 3 + 3 * u ** 2, h11 = u ** 3 - u ** 2;
          return [h00 * k0.x + h10 * m0x + h01 * k1.x + h11 * m1x, h00 * k0.y + h10 * m0y + h01 * k1.y + h11 * m1y];
        }
        function rng(seed = 1) {
          let s = seed >>> 0 || 1;
          return () => {
            s ^= s << 13;
            s ^= s >>> 17;
            s ^= s << 5;
            return (s >>> 0) / 4294967296;
          };
        }
        function wordRise(t, t0, { zeta = 0.6, omega = 22, dist = 26, s0 = 0.94, ds = 0.06, fade = 1.5 } = {}) {
          const k = spring(t - t0, zeta, omega);
          return { k, op: clamp(k * fade, 0, 1), y: (1 - k) * dist, s: s0 + ds * k };
        }
        function letterDrop(t, t0, i, { stagger = 0.055, zeta = 0.5, omega = 26, dist = 46, squash: squash2 = 75e-4, max = 0.22, widen = 0.6, fade = 1.6, h = 0.012 } = {}) {
          const tau = t - t0 - i * stagger;
          const k = spring(tau, zeta, omega), dk = (spring(tau, zeta, omega) - spring(tau - h, zeta, omega)) / h;
          const sq = clamp(Math.abs(dk) * squash2, 0, max);
          return { k, sq, op: clamp(k * fade, 0, 1), y: (1 - k) * dist, sx: 1 + sq * widen, sy: 1 - sq };
        }
        function popIn(t, t0, { zeta = 0.62, omega = 18, rise = 36, s0 = 0.94, ds = 0.06, fade = 1.5 } = {}) {
          const k = spring(t - t0, zeta, omega);
          return { k, op: clamp(k * fade, 0, 1), s: s0 + ds * k, dy: (1 - k) * rise };
        }
        function liftOut(t, t1, { dur = 0.22, dir = -1, dist = 90, blur = 10, grow = 0.03 } = {}) {
          const k = ssstep(t1, t1 + dur, t);
          return { k, op: 1 - k, dy: dir * k * dist, blur: k * blur, s: 1 + grow * k };
        }
        function maskRise(t, t0, i = 0, { stagger = 0.13, zeta = 0.47, omega = 17, dist = 1 } = {}) {
          const k = spring(t - t0 - i * stagger, zeta, omega);
          return { k, y: (1 - k) * dist, visible: k > 0 };
        }
        function typeOn(t, t0, text, { cps = 38, blink = 2.4 } = {}) {
          const n = clamp(Math.floor((t - t0) * cps), 0, text.length);
          return { n, str: text.slice(0, n), done: n >= text.length, caret: n < text.length || Math.floor(t * blink) % 2 === 0 ? 1 : 0 };
        }
        function tick(t, tl, { zeta = 0.5, omega = 28 } = {}) {
          const on = t >= tl, k = spring(t - tl, zeta, omega);
          return { on, k, s: on ? 0.8 + 0.2 * k + 0.25 * (1 - k) : 1 };
        }
        function flyThrough(t, t0, hold, {
          from = 1500,
          to = 0,
          exit = -1700,
          zeta = 0.78,
          omega = 14,
          out = 0.28,
          blurIn = 10,
          blurOut = 12,
          rotY0 = -18,
          rotY1 = -9,
          rotOut = 10,
          rotX = 4,
          s0 = 0.92,
          pre = 0.02,
          post = 0.35
        } = {}) {
          const t1 = t0 + hold, visible = t >= t0 - pre && t < t1 + post;
          const kin = spring(t - t0, zeta, omega), kout = ssstep(t1, t1 + out, t), kc = Math.min(1, kin);
          return {
            visible,
            kin,
            kout,
            x: lerp(from, to, kin) + kout * exit,
            blur: Math.max((1 - kc) * blurIn, kout * blurOut),
            rotY: lerp(rotY0, rotY1, kc) + kout * rotOut,
            rotX,
            s: lerp(s0, 1, kc),
            op: 1 - kout
          };
        }
        function morphRect(t, t0, t1, A, B, { curve = ease.expoOut, spring: sp = null } = {}) {
          var _a, _b, _c, _d;
          const k = sp ? spring(t - t0, (_a = sp.zeta) != null ? _a : 0.7, (_b = sp.omega) != null ? _b : 16) : curve(seg(t, t0, t1));
          const x = lerp(A.x, B.x, k), y = lerp(A.y, B.y, k), w = lerp(A.w, B.w, k), h = lerp(A.h, B.h, k);
          return { k, x, y, w, h, r: lerp((_c = A.r) != null ? _c : 0, (_d = B.r) != null ? _d : 0, k), cx: x + w / 2, cy: y + h / 2 };
        }
        function iris(t, t0, t1, cx, cy, { W = 1920, H = 1080, curve = ease.expoOut, r0 = 0 } = {}) {
          const k = curve(seg(t, t0, t1));
          const far = Math.max(Math.hypot(cx, cy), Math.hypot(W - cx, cy), Math.hypot(cx, H - cy), Math.hypot(W - cx, H - cy)) + 2;
          return { k, cx, cy, r: lerp(r0, far, k), covered: k >= 1 };
        }
        function zoomThrough(t, t0, t1, target, { W = 1920, H = 1080, curve = ease.expoInOut, fit = "cover" } = {}) {
          const k = curve(seg(t, t0, t1));
          const sEnd = fit === "contain" ? Math.min(W / target.w, H / target.h) : Math.max(W / target.w, H / target.h);
          const s = Math.exp(Math.log(sEnd) * k);
          const tcx = target.x + target.w / 2, tcy = target.y + target.h / 2;
          const px = lerp(tcx, W / 2, k), py = lerp(tcy, H / 2, k);
          const tx = px - s * tcx, ty = py - s * tcy;
          return { k, s, tx, ty, matrix: [s, 0, 0, s, tx, ty] };
        }
        function hop(t, t0, t1, from, to, { height = 200, curve = ease.smoother } = {}) {
          const k = curve(seg(t, t0, t1));
          return { k, x: lerp(from.x, to.x, k), y: lerp(from.y, to.y, k) - Math.sin(k * Math.PI) * height };
        }
        function gather(t, t0, t1, i, n, from, to, { stagger = 0.08, arc = 120, spin = 0.4, curve = ease.smoother } = {}) {
          const k = curve(seg(t, t0 + i * stagger, t1 + i * stagger)), o = i - (n - 1) / 2, bump = Math.sin(k * Math.PI);
          return { k, x: lerp(from.x, to.x, k), y: lerp(from.y, to.y, k) - bump * arc, rot: bump * o * spin };
        }
        function ribbon(t, switches, { dur = 0.35, amp = 55, decay = 7, omega = 22, tilt = 0.08, stretchX = 0.24, stretchY = 0.15, lag = 1.8, curve = ease.smoother } = {}) {
          let shift = 0, r = 0;
          for (const ts of switches) {
            shift += curve(seg(t, ts, ts + dur));
            r += ring(t - ts, decay, omega);
          }
          const stretch = Math.abs(r);
          return { shift, index: Math.round(shift), wobble: r * amp, rot: r * tilt, sx: 1 + stretch * stretchX, sy: 1 - stretch * stretchY, textDx: -r * amp * lag };
        }
        function seal(t, t0, t1, { r = 235, turns = 1, curve = ease.smoother } = {}) {
          const k = curve(seg(t, t0, t1));
          return { k, r: r * k, rot: k * turns * Math.PI * 2 };
        }
        function staccato(t, list) {
          let word = "", i = -1;
          for (let j = 0; j < list.length; j++) if (t >= list[j][0]) {
            word = list[j][1];
            i = j;
          }
          return { word, i };
        }
        function impact(t, tHit, { decay = 7, omega = 22, sqx = 0.13, sqy = 0.16 } = {}) {
          const r = ring(t - tHit, decay, omega);
          return { r, sx: 1 + r * sqx, sy: 1 - r * sqy };
        }
        function impactSplit(t, tHit, x, cx, {
          width = 600,
          spread = 65,
          bounce = 65,
          rot = 0.18,
          falloff = 3,
          open = [-0.01, 0.48],
          close = [0.63, 0.98],
          decay = 7,
          omega = 22,
          curve = ease.smoother
        } = {}) {
          const d = (x - cx) / width, r = ring(t - tHit, decay, omega);
          const apart = curve(seg(t, tHit + open[0], tHit + open[1])) * (1 - curve(seg(t, tHit + close[0], tHit + close[1])));
          return { dx: Math.sign(d) * apart * spread, dy: r * bounce * Math.exp(-d * d * falloff), rot: r * d * rot };
        }
        function press(t, tc, { depth = 0.16, decay = 10, omega = 30, flash = 0.4 } = {}) {
          const cl = t - tc, sq = cl > 0 ? ring(cl, decay, omega) * depth : 0;
          return { s: 1 + sq, sq, down: cl > 0, active: cl > 0 && cl < flash };
        }
        function cursor(t, knots, clicks = [], { down = 0.84, hold = 0.14 } = {}) {
          const p = spline(knots, t);
          let s = 1;
          for (const c of clicks) {
            const d = t - c;
            if (d >= 0 && d < hold) s = down;
          }
          return { x: p[0], y: p[1], s };
        }
        function squash(vx, vy, { k = 12e-4, max = 0.45, kY = 8e-4, maxY = 0.3 } = {}) {
          const sp = Math.hypot(vx, vy);
          return { speed: sp, ang: Math.atan2(vy, vx), sx: 1 + clamp(sp * k, 0, max), sy: 1 - clamp(sp * kY, 0, maxY) };
        }
        const SDT = 1 / 240;
        const sampler = (st, t0, per) => (t) => st[clamp(Math.floor((t - t0) / per), 0, st.length - 1)];
        const sim = {
          SDT,
          magnet(card, hand, { B = { x: 230, y: 158 }, R = 150, pull = 0.36, K = 120, damp = 0.85 } = {}) {
            const D = Math.pow(damp, SDT * 60);
            let x = 0, y = 0, vx = 0, vy = 0;
            const st = [];
            for (let t = card.t; t <= card.out + 0.3; t += SDT) {
              const h = hand(t);
              const dx = h[0] - (card.x + B.x), dy = h[1] - (card.y + B.y), d = Math.hypot(dx, dy);
              let tx = 0, ty = 0;
              if (d < R) {
                const f = pull * (1 - (d / R) ** 2);
                tx = dx * f;
                ty = dy * f;
              }
              vx += (tx - x) * K * SDT;
              vy += (ty - y) * K * SDT;
              vx *= D;
              vy *= D;
              x += vx * SDT;
              y += vy * SDT;
              st.push([x, y]);
            }
            return { st, per: SDT, B, at: sampler(st, card.t, SDT) };
          },
          follow(card, hand, { K = 70, damp = 0.88, home = [230, 140], box = [30, 430, 50, 240], reach = [40, 500, 40, 310] } = {}) {
            const D = Math.pow(damp, SDT * 60);
            let x = home[0], y = home[1], vx = 0, vy = 0;
            const st = [];
            for (let t = card.t; t <= card.out + 0.3; t += SDT) {
              const h = hand(t);
              let tx = clamp(h[0] - card.x, box[0], box[1]), ty = clamp(h[1] - card.y, box[2], box[3]);
              const inside = h[0] > card.x - reach[0] && h[0] < card.x + reach[1] && h[1] > card.y - reach[2] && h[1] < card.y + reach[3];
              if (!inside) {
                tx = home[0];
                ty = home[1];
              }
              vx += (tx - x) * K * SDT;
              vy += (ty - y) * K * SDT;
              vx *= D;
              vy *= D;
              x += vx * SDT;
              y += vy * SDT;
              st.push([x, y, vx, vy]);
            }
            return { st, per: SDT, at: sampler(st, card.t, SDT) };
          },
          // ring of radial springs with neighbour coupling, dented where the hand touches the surface
          jelly(card, hand, { N = 48, C = { x: 230, y: 150 }, R0 = 78, K = 42, CP = 1800, damp = 0.962, reach = 60, dent = 14 } = {}) {
            const D = Math.pow(damp, SDT * 60);
            const r = new Float32Array(N), v = new Float32Array(N);
            const st = [];
            let step = 0;
            for (let t = card.t; t <= card.out + 0.3; t += SDT, step++) {
              const h = hand(t);
              const hx = h[0] - (card.x + C.x), hy = h[1] - (card.y + C.y);
              for (let i = 0; i < N; i++) {
                const th = i / N * Math.PI * 2;
                const px = Math.cos(th) * R0 * (1 + r[i]), py = Math.sin(th) * R0 * (1 + r[i]);
                const d = Math.hypot(hx - px, hy - py);
                let push = 0;
                if (d < reach) {
                  push = -(1 - d / reach) * dent;
                }
                const lap = r[(i + N - 1) % N] + r[(i + 1) % N] - 2 * r[i];
                v[i] += (-r[i] * K + lap * CP + push) * SDT;
                v[i] *= D;
              }
              for (let i = 0; i < N; i++) r[i] += v[i] * SDT;
              if (step % 4 === 0) st.push(Float32Array.from(r));
            }
            return { st, per: SDT * 4, N, C, R0, at: sampler(st, card.t, SDT * 4) };
          },
          // N nodes hanging from (ax, ay), pushed aside by the hand; samples are [x0, y0, x1, y1, …]
          verlet(card, hand, { N = 16, L = 13, ax = 230, ay = 40, damp = 0.985, gravity = 1400, reach = 34, push = 2.2, iters = 3 } = {}) {
            const px = new Float32Array(N), py = new Float32Array(N), ox = new Float32Array(N), oy = new Float32Array(N);
            for (let i = 0; i < N; i++) {
              px[i] = ox[i] = ax;
              py[i] = oy[i] = ay + i * L;
            }
            const st = [];
            let step = 0;
            for (let t = card.t; t <= card.out + 0.3; t += SDT, step++) {
              const h = hand(t);
              const hx = h[0] - card.x, hy = h[1] - card.y;
              for (let i = 1; i < N; i++) {
                let vx = (px[i] - ox[i]) * damp, vy = (py[i] - oy[i]) * damp;
                ox[i] = px[i];
                oy[i] = py[i];
                px[i] += vx;
                py[i] += vy + gravity * SDT * SDT;
                const dx = px[i] - hx, dy = py[i] - hy, d = Math.hypot(dx, dy);
                if (d < reach && d > 0.01) {
                  const f = (reach - d) / reach * push;
                  px[i] += dx / d * f;
                  py[i] += dy / d * f;
                }
              }
              for (let it = 0; it < iters; it++) {
                px[0] = ax;
                py[0] = ay;
                for (let i = 0; i < N - 1; i++) {
                  const dx = px[i + 1] - px[i], dy = py[i + 1] - py[i], d = Math.hypot(dx, dy) || 1e-6, c = (d - L) / d * 0.5;
                  if (i === 0) {
                    px[1] -= dx * c * 2;
                    py[1] -= dy * c * 2;
                  } else {
                    px[i] += dx * c;
                    py[i] += dy * c;
                    px[i + 1] -= dx * c;
                    py[i + 1] -= dy * c;
                  }
                }
              }
              if (step % 4 === 0) {
                const s = new Float32Array(N * 2);
                for (let i = 0; i < N; i++) {
                  s[i * 2] = px[i];
                  s[i * 2 + 1] = py[i];
                }
                st.push(s);
              }
            }
            return { st, per: SDT * 4, N, at: sampler(st, card.t, SDT * 4) };
          }
        };
        function camera(t, keys, { curve = ease.cubicInOut, W = 1920, H = 1080 } = {}) {
          const pick = (k2) => {
            var _a, _b, _c, _d;
            return { x: (_a = k2.x) != null ? _a : W / 2, y: (_b = k2.y) != null ? _b : H / 2, zoom: (_c = k2.zoom) != null ? _c : 1, rot: (_d = k2.rot) != null ? _d : 0 };
          };
          if (!keys.length) return { x: W / 2, y: H / 2, zoom: 1, rot: 0 };
          if (t <= keys[0].t) return pick(keys[0]);
          const L = keys.length;
          if (t >= keys[L - 1].t) return pick(keys[L - 1]);
          let i = 0;
          while (keys[i + 1].t < t) i++;
          const A = pick(keys[i]), B = pick(keys[i + 1]), k = (keys[i + 1].curve || curve)(seg(t, keys[i].t, keys[i + 1].t));
          return { x: lerp(A.x, B.x, k), y: lerp(A.y, B.y, k), zoom: Math.exp(lerp(Math.log(A.zoom), Math.log(B.zoom), k)), rot: lerp(A.rot, B.rot, k) };
        }
        function view(cam, { W = 1920, H = 1080, depth = 0 } = {}) {
          const f = 1 / (1 + Math.max(-0.9, depth));
          const cx = W / 2 + (cam.x - W / 2) * f, cy = H / 2 + (cam.y - H / 2) * f;
          const z = Math.exp(Math.log(cam.zoom) * f), c = Math.cos(cam.rot * f) * z, s = Math.sin(cam.rot * f) * z;
          return [c, s, -s, c, W / 2 - (c * cx - s * cy), H / 2 - (s * cx + c * cy)];
        }
        const dof = (depth, focus = 0, { k = 10, max = 14 } = {}) => Math.min(max, Math.abs(depth - focus) * k);
        function whip(t, t0, dur, dist, { curve = ease.expoInOut } = {}) {
          const k = curve(seg(t, t0, t0 + dur));
          return { k, d: dist * k };
        }
        function shake(t, tHit, { amp = 12, decay = 9, freq = 19, seed = 1 } = {}) {
          const tau = t - tHit;
          if (tau <= 0) return { x: 0, y: 0, rot: 0 };
          const r = rng(seed), fx = freq * (1 + 0.1 * r()), fy = freq * (1.31 + 0.1 * r()), fr = freq * (0.77 + 0.1 * r());
          const e = amp * Math.exp(-decay * tau), w = 2 * Math.PI * tau;
          return { x: e * Math.sin(w * fx), y: 0.7 * e * Math.sin(w * fy), rot: 15e-4 * e * Math.sin(w * fr) };
        }
        const drift = (t, t0, t1, amount = 0.07) => 1 + amount * seg(t, t0, t1);
        const project = (M, x, y) => [M[0] * x + M[2] * y + M[4], M[1] * x + M[3] * y + M[5]];
        const unproject = (M, x, y) => {
          const d = M[0] * M[3] - M[1] * M[2], u = x - M[4], v = y - M[5];
          return [(M[3] * u - M[2] * v) / d, (M[0] * v - M[1] * u) / d];
        };
        function projectBox(M, b) {
          const P = [[b.x, b.y], [b.x + b.w, b.y], [b.x, b.y + b.h], [b.x + b.w, b.y + b.h]].map((p) => project(M, p[0], p[1]));
          const xs = P.map((p) => p[0]), ys = P.map((p) => p[1]), x0 = Math.min(...xs), y0 = Math.min(...ys);
          return { x: x0, y: y0, w: Math.max(...xs) - x0, h: Math.max(...ys) - y0, op: b.op };
        }
        function screenTravel(c0, c1, cMid, { W = 1920, H = 1080, depth = 0 } = {}) {
          const M0 = view(c0, { W, H, depth }), M1 = view(c1, { W, H, depth }), Mm = view(cMid, { W, H, depth });
          let d = 0;
          for (const [sx, sy] of [[0, 0], [W, 0], [0, H], [W, H]]) {
            const [wx, wy] = unproject(Mm, sx, sy), p = project(M0, wx, wy), r = project(M1, wx, wy);
            d = Math.max(d, Math.hypot(p[0] - r[0], p[1] - r[1]));
          }
          return d;
        }
        function lattice(cam, { depth = 1.2, spacing = 48, px = 1.4, W = 1920, H = 1080 } = {}) {
          const M = view(cam, { W, H, depth }), c = [[0, 0], [W, 0], [0, H], [W, H]].map((p) => unproject(M, p[0], p[1]));
          const xs = c.map((p) => p[0]), ys = c.map((p) => p[1]);
          return {
            matrix: M,
            spacing,
            r: px / Math.hypot(M[0], M[1]),
            x0: Math.floor(Math.min(...xs) / spacing) * spacing,
            x1: Math.max(...xs),
            y0: Math.floor(Math.min(...ys) / spacing) * spacing,
            y1: Math.max(...ys)
          };
        }
        const SWIFT = { smooth: 0, snappy: 0.15, bouncy: 0.3 };
        function swiftSpring(tau, kind = "smooth", { duration = 0.5, bounce = null } = {}) {
          var _a;
          const b = (_a = bounce != null ? bounce : SWIFT[kind]) != null ? _a : 0;
          return spring(tau, 1 - b, 2 * Math.PI / duration);
        }
        function lightField(level, { W = 1920, H = 1080, rest = 0.84, top = -300, r0 = 660, r1 = 1500, tilt = 0.012 } = {}) {
          const ry = r0 + r1 * level, horizon = lerp(H * rest, top, level);
          return { cx: W / 2, cy: horizon + 0.62 * ry, rx: ry * 2.3, ry, tilt, horizon, core: 0.5, stops: [0, 0.36, 0.6, 0.8, 1] };
        }
        function ripple(t, t0, { n = 3, stagger = 0.16, dur = 1.25, rMax = 1160, curve = ease.smoother } = {}) {
          const r = [];
          for (let k = 0; k < n; k++) r.push(rMax * curve(seg(t, t0 + k * stagger, t0 + k * stagger + dur)));
          return { r, done: t >= t0 + (n - 1) * stagger + dur };
        }
        function silkHash(x, y, s) {
          let h = x * 374761393 + y * 668265263 + s * 1442695041 | 0;
          h = Math.imul(h ^ h >>> 13, 1274126177);
          return ((h ^ h >>> 16) >>> 0) / 4294967296;
        }
        function silkNoise(x, y, s) {
          const xi = Math.floor(x), yi = Math.floor(y), xf = x - xi, yf = y - yi, u = xf * xf * (3 - 2 * xf), v = yf * yf * (3 - 2 * yf);
          const a = silkHash(xi, yi, s), b = silkHash(xi + 1, yi, s), c = silkHash(xi, yi + 1, s), d = silkHash(xi + 1, yi + 1, s);
          return a + (b - a) * u + (c - a) * v + (a - b - c + d) * u * v;
        }
        const silkFbm = (x, y, s) => 0.5 * silkNoise(x, y, s) + 0.25 * silkNoise(x * 2.02, y * 2.02, s);
        function silkRamp(stops, k) {
          k = clamp(k, 0, 1);
          for (let i = 1; i < stops.length; i++) if (k <= stops[i][0]) {
            const [a, A] = stops[i - 1], [b, B] = stops[i], u = (k - a) / (b - a);
            return A.map((v, j) => v + (B[j] - v) * u);
          }
          return stops[stops.length - 1][1];
        }
        const SILK = {
          ember: [[0, [200, 120, 24]], [0.22, [236, 170, 34]], [0.42, [122, 96, 26]], [0.54, [160, 94, 32]], [0.74, [240, 74, 92]], [1, [252, 210, 198]]],
          peach: [[0, [240, 150, 92]], [0.24, [252, 204, 148]], [0.44, [190, 104, 66]], [0.58, [236, 124, 108]], [0.8, [250, 186, 172]], [1, [255, 240, 228]]],
          dusk: [[0, [118, 58, 94]], [0.24, [226, 98, 112]], [0.44, [88, 44, 68]], [0.58, [176, 74, 98]], [0.8, [246, 150, 122]], [1, [255, 224, 204]]]
        };
        function silk(tau, seed = 3, stops = SILK.peach, { gx = 16, gy = 20, contrast = 3.4, out = null } = {}) {
          const d = out || new Uint8ClampedArray(gx * gy * 4);
          for (let j = 0; j < gy; j++) for (let i = 0; i < gx; i++) {
            const u = i / gx * 1.1, v = j / gy * 1.4;
            const qx = silkFbm(u + 0.11 * tau, v - 0.07 * tau, seed), qy = silkFbm(u + 5.2 - 0.09 * tau, v + 1.3 + 0.05 * tau, seed);
            const k = 0.5 + (silkFbm(u + 1.8 * qx + 0.04 * tau, v + 1.8 * qy, seed) - 0.375) * contrast;
            const c = silkRamp(stops, k), n = (i + j * gx) * 4;
            d[n] = c[0];
            d[n + 1] = c[1];
            d[n + 2] = c[2];
            d[n + 3] = 255;
          }
          return d;
        }
        silk.ramps = SILK;
        silk.ramp = silkRamp;
        function carouselLoop({ dur, start = 0, speed = 204, rampDur = 1, stop = null, hz = 240 } = {}) {
          const n = Math.ceil(dur * hz) + 1, X = new Float64Array(n), TA = new Float64Array(n);
          let x = 0, tau = 0;
          for (let i = 0; i < n; i++) {
            const t = i / hz, k = stop ? 1 - ease.smooth(seg(t, stop[0], stop[1])) : 1;
            x += speed * swiftSpring(t - start, "smooth", { duration: rampDur }) * k / hz;
            tau += k / hz;
            X[i] = x;
            TA[i] = tau;
          }
          return { at(t) {
            const f = clamp(t * hz, 0, n - 1), i = Math.floor(f), j = Math.min(n - 1, i + 1), u = f - i;
            return { x: lerp(X[i], X[j], u), tau: lerp(TA[i], TA[j], u) };
          } };
        }
        const OM = {
          version: "1.1.0-lite",
          lineage: "otk-7f3e1c",
          clamp,
          lerp,
          seg,
          sstep,
          ssstep,
          ease,
          bezier,
          tween,
          t80,
          spring,
          springVel,
          ring,
          settle,
          spline,
          rng,
          wordRise,
          letterDrop,
          popIn,
          liftOut,
          maskRise,
          typeOn,
          tick,
          flyThrough,
          morphRect,
          iris,
          zoomThrough,
          hop,
          gather,
          ribbon,
          seal,
          staccato,
          impact,
          impactSplit,
          press,
          cursor,
          squash,
          sim,
          camera,
          view,
          dof,
          whip,
          shake,
          drift,
          lattice,
          project,
          unproject,
          projectBox,
          screenTravel,
          swiftSpring,
          lightField,
          ripple,
          silk,
          carouselLoop
        };
        root.OM = OM;
        if (typeof module === "object" && module.exports) module.exports = OM;
      })(typeof window !== "undefined" ? window : globalThis);
    }
  });

  // lib/dealer-film/data.js
  var require_data = __commonJS({
    "lib/dealer-film/data.js"(exports, module) {
      "use strict";
      var ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
      var TIRE_SIZE = /^(\d{3}\/\d{2}Z?R\d{2}(\.5)?|\d{2}X\d{1,2}\.\d{2}R\d{2})$/;
      var SETTING_KEYS = {
        asOf: "stat_as_of",
        ctCheckedOn: "stat_ct_checked_on",
        sizes: "stat_sizes",
        inStockPct: "stat_in_stock_pct",
        set4Pct: "stat_set4_pct",
        set16Pct: "stat_set16_pct",
        tiresOnHand: "stat_tires_on_hand",
        sold12m: "stat_sold_12m",
        accounts: "stat_accounts",
        repeatPct: "stat_repeat_pct",
        ordersPerDay: "stat_orders_per_day",
        fsaCount: "stat_fsa_count",
        cityCount: "stat_city_count",
        winterTires: "stat_winter_tires",
        whOakville: "stat_wh_oakville",
        whCambridge: "stat_wh_cambridge",
        whNorthYork: "stat_wh_north_york",
        sameDayPct: "stat_same_day_pct",
        cascade: "stat_cascade_sizes",
        // comma-joined in the template, string[] in the snapshot
        sizeList: "stat_size_list"
        // the same: every in-stock size
      };
      var DATE_FIELDS = ["asOf", "ctCheckedOn"];
      var PCT_FIELDS = ["inStockPct", "set4Pct", "set16Pct"];
      var COUNT_FIELDS = ["sizes", "tiresOnHand", "sold12m"];
      var POSITIVE_FIELDS = ["accounts", "ordersPerDay", "fsaCount", "cityCount", "winterTires", "whOakville", "whCambridge", "whNorthYork"];
      function isPositive(n) {
        return typeof n === "number" && isFinite(n) && n > 0;
      }
      function cents(n) {
        return Math.round(n * 100) / 100;
      }
      function usableRow(row) {
        return !!row && isPositive(row.save) && isPositive(row.ct) && row.ct > row.save;
      }
      function pickHeroSize(rows) {
        var best = null;
        var bestSave = -Infinity;
        for (var i = 0; i < rows.length; i++) {
          if (!usableRow(rows[i])) continue;
          var save = Math.round(rows[i].save * 100);
          if (save > bestSave) {
            best = rows[i];
            bestSave = save;
          }
        }
        return best;
      }
      function marginPerTire(row) {
        return row.save;
      }
      function marginPerSet(row) {
        return cents(4 * row.save);
      }
      function marginPer16(row) {
        return cents(16 * row.save);
      }
      function displayValues(snap) {
        return {
          fsaApprox: Math.round(snap.fsaCount / 10) * 10,
          cityFloor: Math.floor(snap.cityCount / 10) * 10,
          ordersApprox: Math.round(snap.ordersPerDay),
          repeatRound: Math.round(snap.repeatPct),
          inStockRound: Math.round(snap.inStockPct),
          set4Round: Math.round(snap.set4Pct),
          set16Round: Math.round(snap.set16Pct)
        };
      }
      var MONEY = {
        en: new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" }),
        fr: new Intl.NumberFormat("fr-CA", { style: "currency", currency: "CAD" })
      };
      function formatMoney(n, locale) {
        var s = MONEY[locale === "fr" ? "fr" : "en"].format(n);
        return s.replace(/[   ]/g, "\xA0");
      }
      function formatTime(min, locale) {
        var h = Math.floor(min / 60);
        var m = ("0" + min % 60).slice(-2);
        return locale === "fr" ? h + "\xA0h\xA0" + m : h + ":" + m;
      }
      function formatCopy(tpl, values) {
        return String(tpl).replace(/\[(\w+)\]/g, function(m, name) {
          return Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : m;
        });
      }
      function validateSnapshot(s) {
        var errs = [];
        if (!s || typeof s !== "object") return ["snapshot missing"];
        DATE_FIELDS.forEach(function(k) {
          if (typeof s[k] !== "string" || !ISO_DATE.test(s[k])) errs.push(k + " is not YYYY-MM-DD");
        });
        PCT_FIELDS.forEach(function(k) {
          if (!isPositive(s[k]) || s[k] > 100) errs.push(k + " is not above 0 and at most 100");
        });
        COUNT_FIELDS.forEach(function(k) {
          if (!isPositive(s[k]) || Math.floor(s[k]) !== s[k]) errs.push(k + " is not a whole number above 0");
        });
        POSITIVE_FIELDS.forEach(function(k) {
          if (!isPositive(s[k])) errs.push(k + " is not a number above 0");
        });
        if (!isPositive(s.repeatPct) || s.repeatPct > 100) errs.push("repeatPct is not above 0 and at most 100");
        if (!Array.isArray(s.cascade) || s.cascade.length === 0) {
          errs.push("cascade is empty");
        } else {
          s.cascade.forEach(function(c, i) {
            if (typeof c !== "string" || !c.trim()) errs.push("cascade[" + i + "] is empty");
            else if (c.indexOf(",") !== -1) errs.push("cascade[" + i + "] contains a comma");
          });
        }
        if (s.sizeList !== void 0 && !Array.isArray(s.sizeList)) {
          errs.push("sizeList is not a list");
        } else if (s.sizeList && s.sizeList.length) {
          if (s.sizeList.length !== s.sizes) errs.push("sizeList has " + s.sizeList.length + " sizes, not " + s.sizes);
          s.sizeList.forEach(function(c, i) {
            if (typeof c !== "string" || !TIRE_SIZE.test(c)) errs.push("sizeList[" + i + "] is not a tire size");
          });
          if (Array.isArray(s.cascade)) {
            s.cascade.forEach(function(c, i) {
              if (s.sizeList.indexOf(c) === -1) errs.push("cascade[" + i + "] is not in sizeList");
            });
          }
          var hero = Array.isArray(s.rows) ? pickHeroSize(s.rows) : null;
          if (hero && s.sizeList.indexOf(hero.size) === -1) errs.push("the hero size is not in sizeList");
        }
        if (!Array.isArray(s.rows) || s.rows.length === 0) {
          errs.push("rows is empty");
        } else {
          if (!usableRow(s.rows[0])) errs.push("rows[0] (the hero) is not usable");
          s.rows.forEach(function(r, i) {
            if (r && "dealer" in r) errs.push("rows[" + i + "] carries a dealer price");
            if (!r || typeof r.size !== "string" || !r.size) errs.push("rows[" + i + "].size missing");
            if (!r || typeof r.ctLabel !== "string") errs.push("rows[" + i + "].ctLabel missing");
          });
        }
        if (s.sameDayPct !== null && s.sameDayPct !== void 0 && (!isPositive(s.sameDayPct) || s.sameDayPct > 100)) {
          errs.push("sameDayPct is not above 0 and at most 100");
        }
        return errs;
      }
      function riverSizes(snap) {
        return snap.sizeList && snap.sizeList.length ? snap.sizeList : snap.cascade;
      }
      function splitSizes(v) {
        return String(v || "").split(",").map(function(x) {
          return x.trim();
        }).filter(Boolean);
      }
      function snapshotFromTemplate(tpl) {
        var body = tpl.sections.dealer_body;
        var set = body.settings || {};
        var snap = {};
        Object.keys(SETTING_KEYS).forEach(function(k) {
          snap[k] = set[SETTING_KEYS[k]];
        });
        var sd = set[SETTING_KEYS.sameDayPct];
        snap.sameDayPct = sd === void 0 || sd === null || sd === "" || Number(sd) === 0 ? null : Number(sd);
        snap.cascade = splitSizes(set[SETTING_KEYS.cascade]);
        snap.sizeList = splitSizes(set[SETTING_KEYS.sizeList]);
        snap.rows = (body.block_order || []).map(function(id) {
          return body.blocks[id];
        }).filter(function(b) {
          return b && b.type === "price_row";
        }).map(function(b) {
          return {
            size: b.settings.size,
            ct: Number(b.settings.ct_price),
            save: Number(b.settings.save),
            ctLabel: b.settings.ct_label
          };
        });
        return snap;
      }
      module.exports = {
        SETTING_KEYS,
        usableRow,
        pickHeroSize,
        riverSizes,
        marginPerTire,
        marginPerSet,
        marginPer16,
        displayValues,
        formatMoney,
        formatCopy,
        formatTime,
        validateSnapshot,
        snapshotFromTemplate
      };
    }
  });

  // lib/dealer-film/grid.js
  var require_grid = __commonJS({
    "lib/dealer-film/grid.js"(exports, module) {
      "use strict";
      var BPM = 121;
      var BEAT = 0.495873;
      var BAR = 4 * BEAT;
      var FIRST_BAR = 1.632;
      var DURATION = 85.4;
      var PEAK = 78.47;
      var FINAL_HIT = 83.45;
      var AUDIO_OFFSET = 0;
      function barStart(n) {
        return FIRST_BAR + (n - 1) * BAR;
      }
      function beatAt(bar, beat) {
        return barStart(bar) + (beat - 1) * BEAT;
      }
      function isOnGrid(t, tol) {
        if (t === 0) return true;
        if (tol === void 0) tol = 0.017;
        var k = Math.max(-3, Math.round((t - FIRST_BAR) / BEAT));
        return Math.abs(t - (FIRST_BAR + k * BEAT)) <= tol;
      }
      function isOn16(t, tol) {
        if (tol === void 0) tol = 0.017;
        var s16 = BEAT / 4;
        return Math.abs(t - (FIRST_BAR + Math.round((t - FIRST_BAR) / s16) * s16)) <= tol;
      }
      module.exports = {
        isOn16,
        BPM,
        BEAT,
        BAR,
        FIRST_BAR,
        DURATION,
        PEAK,
        FINAL_HIT,
        AUDIO_OFFSET,
        barStart,
        beatAt,
        isOnGrid
      };
    }
  });

  // lib/dealer-film/kit.js
  var require_kit = __commonJS({
    "lib/dealer-film/kit.js"(exports, module) {
      "use strict";
      var OM = require_onetake_motion();
      var data = require_data();
      var grid = require_grid();
      var ease = OM.ease;
      var BEAT = grid.BEAT;
      var S16 = BEAT / 4;
      var M = 16;
      var COUNT = new Intl.NumberFormat("en-CA");
      function R(x, y, w, h) {
        return { x, y, w, h };
      }
      function centred(S, w, h) {
        return R(S.x + (S.w - w) / 2, S.y + (S.h - h) / 2, w, h);
      }
      function cell(r, cols, rows, i) {
        var w = r.w / cols;
        var h = r.h / rows;
        return R(r.x + i % cols * w, r.y + Math.floor(i / cols) * h, w, h);
      }
      function piece(r, tone, opacity) {
        return { x: r.x, y: r.y, w: r.w, h: r.h, tone, opacity: opacity === void 0 ? 1 : opacity };
      }
      function storefront(r, tone) {
        var a = Math.max(3, Math.round(0.18 * r.h));
        var o = Math.round(0.1 * r.w);
        return [piece(R(r.x, r.y + a + 2, r.w, r.h - a - 2), tone), piece(R(r.x - o, r.y, r.w + 2 * o, a), tone)];
      }
      var LABEL_PX = 14;
      function labelBox(l, text) {
        var w = 0.66 * LABEL_PX * text.length;
        return R(l.right ? l.x - w : l.x, l.y - 0.6 * LABEL_PX, w, 1.2 * LABEL_PX);
      }
      function stackRects(base, n, cols, cellH, gap) {
        var w = (base.w - (cols - 1) * gap) / cols;
        var out = [];
        for (var i = 0; i < n; i++) {
          var row = Math.floor(i / cols);
          out.push(R(base.x + i % cols * (w + gap), base.y - (row + 1) * cellH - row * gap, w, cellH));
        }
        return out;
      }
      function outside(r, g) {
        var x0 = Math.max(r.x, g.x);
        var x1 = Math.min(r.x + r.w, g.x + g.w);
        var y0 = Math.max(r.y, g.y);
        var y1 = Math.min(r.y + r.h, g.y + g.h);
        if (x0 >= x1 || y0 >= y1) return [r];
        return [
          R(r.x, r.y, r.w, y0 - r.y),
          R(r.x, y1, r.w, r.y + r.h - y1),
          R(r.x, y0, x0 - r.x, y1 - y0),
          R(x1, y0, r.x + r.w - x1, y1 - y0)
        ].filter(function(b) {
          return b.w > 1e-9 && b.h > 1e-9;
        });
      }
      function blueRects(f) {
        var rs = [];
        if (f.block && f.block.opacity > 0.01) rs.push(f.block);
        if (f.bars && (f.bars.tone ? f.bars.tone.dealer : "blue") === "blue") rs.push(f.bars.dealer);
        (f.pieces || []).forEach(function(p) {
          if ((p.tone === "blue" || p.tone === "navy") && p.opacity > 0.01) rs.push(p);
        });
        (f.branches || []).forEach(function(b) {
          if (b.tone !== "blue" || !(b.p > 0)) return;
          var d = drawn(b);
          var xs = d.map(function(q) {
            return q.x;
          });
          var ys = d.map(function(q) {
            return q.y;
          });
          var x0 = Math.min.apply(null, xs);
          var y0 = Math.min.apply(null, ys);
          rs.push(R(x0, y0, Math.max.apply(null, xs) - x0, Math.max.apply(null, ys) - y0));
        });
        var gr = f.grid;
        if (!gr) return rs;
        var lit = [];
        for (var i = 0; i < Math.min(gr.lit, gr.cols * gr.rows); i++) lit.push(cell(f.block, gr.cols, gr.rows, i));
        return rs.reduce(function(out, r) {
          return out.concat(outside(r, f.block));
        }, lit);
      }
      function drawn(b) {
        var pts = b.pts;
        var lens = [];
        var total = 0;
        for (var i = 1; i < pts.length; i++) total += lens[i] = Math.hypot(pts[i].x - pts[i - 1].x, pts[i].y - pts[i - 1].y);
        var left = total * Math.min(1, b.p);
        var out = [pts[0]];
        for (var k = 1; k < pts.length && left > 0; k++) {
          if (lens[k] <= left) {
            out.push(pts[k]);
            left -= lens[k];
          } else {
            var u = left / lens[k];
            out.push({ x: pts[k - 1].x + (pts[k].x - pts[k - 1].x) * u, y: pts[k - 1].y + (pts[k].y - pts[k - 1].y) * u });
            left = 0;
          }
        }
        return out;
      }
      function blueBox(f) {
        var rs = blueRects(f);
        if (!rs.length) return null;
        var x0 = Math.min.apply(null, rs.map(function(r) {
          return r.x;
        }));
        var y0 = Math.min.apply(null, rs.map(function(r) {
          return r.y;
        }));
        var x1 = Math.max.apply(null, rs.map(function(r) {
          return r.x + r.w;
        }));
        var y1 = Math.max.apply(null, rs.map(function(r) {
          return r.y + r.h;
        }));
        return R(x0, y0, x1 - x0, y1 - y0);
      }
      function within(r, S) {
        var w = Math.min(r.w, S.w);
        var h = Math.min(r.h, S.h);
        return R(OM.clamp(r.x, S.x, S.x + S.w - w), OM.clamp(r.y, S.y, S.y + S.h - h), w, h);
      }
      function morph(t, t0, dur, A, B, curve) {
        var m = OM.morphRect(t, t0, t0 + dur, A, B, { curve: curve || ease.expoOut });
        return R(m.x, m.y, m.w, m.h);
      }
      function springTo(t, t0, A, B, zeta, omega) {
        var m = OM.morphRect(t, t0, t0, A, B, { spring: { zeta: zeta || 0.6, omega: omega || 16 } });
        return R(m.x, m.y, m.w, m.h);
      }
      function hitIndex(t, times) {
        var j = -1;
        for (var i = 0; i < (times || []).length && t >= times[i]; i++) j = i;
        return j;
      }
      var RING_PEAK = OM.impact(Math.atan(22 / 7) / 22, 0).r;
      var ACCENT_FLOOR = 9;
      var HOLD_TICK = 8;
      function accentMin(P) {
        return Math.max(ACCENT_FLOOR, 0.025 * P.stage.h);
      }
      function floored(r, opts) {
        if (!opts || !(opts.min > 0)) return opts;
        var sx = opts.sqx === void 0 ? 0.13 : opts.sqx;
        var sy = opts.sqy === void 0 ? 0.16 : opts.sqy;
        var peak = RING_PEAK * Math.max(Math.abs(sx) * r.w, Math.abs(sy) * r.h);
        var k = peak > 0 && peak < opts.min ? opts.min / peak : 1;
        return Object.assign({}, opts, { sqx: sx * k, sqy: sy * k });
      }
      function squash(r, t, tHit, anchor, opts) {
        var tau = t - tHit;
        if (!(tau > 0) || tau > 1) return r;
        var k = OM.impact(t, tHit, floored(r, opts));
        var w = r.w * k.sx;
        var h = r.h * k.sy;
        return R(r.x + (r.w - w) / 2, anchor === "bottom" ? r.y + r.h - h : r.y + (r.h - h) / 2, w, h);
      }
      function afterRing(opts, gap) {
        var left = gap > 0 && gap <= 1 ? Math.max(0, OM.impact(gap, 0).r) : 0;
        return opts && opts.min > 0 && left > 0 ? Object.assign({}, opts, { min: opts.min * RING_PEAK / (RING_PEAK - left) }) : opts;
      }
      function accent(r, t, times, anchor, opts) {
        var j = hitIndex(t, times);
        return j < 0 ? r : squash(r, t, times[j], anchor, j ? afterRing(opts, times[j] - times[j - 1]) : opts);
      }
      function pulse(r, t, cue, amt, from, min) {
        var k = Math.floor((t - cue.start) / BEAT + 1e-9);
        var a = amt || 0.03;
        return k < (from || 0) ? r : squash(r, t, cue.start + k * BEAT, "bottom", { sqx: a * 0.6, sqy: a, min });
      }
      function beatOf(t, cue) {
        return Math.floor((t - cue.start) / BEAT + 1e-9);
      }
      function batch(j, N, total) {
        var n = 0;
        for (var i = 0; i <= j && i < N; i++) n += Math.ceil((total - n) / (N - i));
        return n;
      }
      function on16(t) {
        return grid.FIRST_BAR + Math.floor((t - grid.FIRST_BAR) / S16 + 1e-9) * S16;
      }
      function fadeIn(t, t0, dur) {
        return OM.tween(t, t0, t0 + (dur || 0.2), ease.quartOut);
      }
      function money(x) {
        return data.formatMoney(x, "en");
      }
      function count(n) {
        return COUNT.format(n);
      }
      function num(n) {
        return { n: count(n), nRaw: n };
      }
      function pct(p) {
        return { pct: count(p), pctRaw: p };
      }
      function clockTime(min) {
        return { time: data.formatTime(min, "en"), timeRaw: min };
      }
      function marginValues(x) {
        return { margin: money(x), marginRaw: x };
      }
      function rowMargin(row) {
        var m = marginValues(data.marginPerTire(row));
        return { size: row.size, margin: m.margin, marginRaw: m.marginRaw };
      }
      var VALUES = {
        accounts: function(P, s) {
          return num(s.accounts);
        },
        repeat: function(P) {
          return pct(P.dv.repeatRound);
        },
        sizes: function(P, s) {
          return num(s.sizes);
        },
        cascade_size: function(P) {
          return { size: P.hero.size };
        },
        ct_cheapest: function(P) {
          return { size: P.hero.size };
        },
        margin_tire: function(P) {
          return marginValues(data.marginPerTire(P.hero));
        },
        margin_set: function(P) {
          return marginValues(data.marginPerSet(P.hero));
        },
        margin_16: function(P) {
          return marginValues(data.marginPer16(P.hero));
        },
        peak_margin: function(P) {
          return marginValues(data.marginPerTire(P.hero));
        },
        carousel: function(P) {
          return rowMargin(P.hero);
        },
        in_stock: function(P) {
          return pct(P.dv.inStockRound);
        },
        set4: function(P) {
          return pct(P.dv.set4Round);
        },
        set16: function(P) {
          return pct(P.dv.set16Round);
        },
        on_shelf: function(P, s) {
          return num(s.tiresOnHand);
        },
        wh_split: function(P, s) {
          return {
            oak: count(s.whOakville),
            oakRaw: s.whOakville,
            cam: count(s.whCambridge),
            camRaw: s.whCambridge,
            ny: count(s.whNorthYork),
            nyRaw: s.whNorthYork
          };
        },
        winter: function(P, s) {
          return num(s.winterTires);
        },
        zones: function(P) {
          return num(P.dv.fsaApprox);
        },
        cities: function(P) {
          return num(P.dv.cityFloor);
        },
        orders_day: function(P) {
          return num(P.dv.ordersApprox);
        },
        team: function(P, s) {
          return num(s.accounts);
        },
        // "[n] shops. One team." stays in step with accounts
        same_day: function(P, s) {
          return s.sameDayPct === null || s.sameDayPct === void 0 ? void 0 : pct(Math.round(s.sameDayPct));
        }
      };
      function values(key, P, snap) {
        return VALUES[key] ? VALUES[key](P, snap) : void 0;
      }
      function copy(list, key, opacity, vals) {
        if (!(opacity > 0)) return list;
        var e = { key, opacity: Math.min(1, opacity) };
        if (vals) e.values = vals;
        list.push(e);
        return list;
      }
      module.exports = {
        OM,
        ease,
        BEAT,
        S16,
        M,
        RING_PEAK,
        ACCENT_FLOOR,
        HOLD_TICK,
        accentMin,
        afterRing,
        R,
        centred,
        cell,
        piece,
        storefront,
        LABEL_PX,
        labelBox,
        stackRects,
        within,
        drawn,
        blueRects,
        blueBox,
        morph,
        springTo,
        hitIndex,
        batch,
        squash,
        accent,
        pulse,
        beatOf,
        on16,
        fadeIn,
        money,
        count,
        num,
        pct,
        clockTime,
        marginValues,
        rowMargin,
        values,
        copy
      };
    }
  });

  // lib/dealer-film/onsets.json
  var require_onsets = __commonJS({
    "lib/dealer-film/onsets.json"(exports, module) {
      module.exports = { s16: 0.12396825, stems: { drums: [72, 80, 88, 96, 104, 112, 132, 136, 140, 144, 148, 152, 156, 160, 164, 168, 172, 176, 180, 184, 188, 192, 196, 200, 204, 208, 212, 216, 220, 224, 228, 232, 236, 240, 244, 248, 252, 256, 258, 259, 260, 264, 268, 272, 276, 280, 284, 288, 292, 296, 300, 304, 308, 312, 316, 320, 324, 326, 328, 332, 336, 340, 344, 348, 352, 356, 360, 364, 368, 372, 404, 408, 412, 416, 420, 424, 428, 432, 436, 440, 444, 448, 452, 456, 460, 464, 468, 470, 472, 474, 476, 478, 480, 482, 484, 486, 488, 490, 492, 494, 496, 498, 500, 502, 504, 506, 508, 510, 512, 514, 516, 518, 520, 522, 524, 526, 528, 530, 596, 600, 604, 608, 612, 616, 620, 624, 628], brass: [92, 94, 96, 98, 99, 100, 102, 103, 104, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 516, 520, 522, 524, 525, 526, 528, 529, 530, 531, 676], keys: [6, 8, 12, 16, 20, 22, 26, 28, 34, 38, 40, 44, 50, 54, 56, 58, 60, 62, 64, 66, 68, 70, 72, 76, 78, 80, 84, 86, 88, 90, 92, 94, 96, 98, 100, 102, 104, 106, 108, 110, 112, 114, 116, 118, 120, 122, 124, 126, 128, 130, 134, 138, 142, 146, 150, 154, 158, 162, 166, 170, 178, 182, 186, 190, 194, 198, 202, 206, 210, 218, 222, 226, 234, 238, 242, 246, 250, 253, 254, 257, 258, 259, 265, 266, 267, 270, 274, 278, 281, 282, 283, 286, 290, 294, 297, 298, 299, 302, 306, 310, 313, 314, 315, 318, 322, 329, 330, 331, 334, 338, 342, 345, 346, 347, 350, 354, 358, 361, 362, 363, 366, 370, 374, 376, 378, 380, 382, 384, 386, 388, 390, 392, 394, 396, 398, 400, 402, 406, 410, 414, 418, 420, 422, 426, 430, 434, 436, 438, 442, 446, 450, 454, 458, 459, 461, 462, 466, 470, 474, 478, 482, 486, 490, 491, 494, 498, 502, 506, 510, 514, 518, 522, 523, 525, 526, 529, 530, 531, 532, 534, 536, 538, 540, 544, 548, 550, 552, 554, 556, 560, 562, 564, 566, 568, 572, 580, 582, 584, 588, 592, 598, 602, 606, 610, 614, 618, 622, 626, 628, 632, 636, 640, 644, 648, 652, 656, 676], synth: [0, 8, 12, 16, 18, 26, 28, 32, 34, 40, 44, 46, 48, 50, 54, 56, 58, 60, 62, 64, 66, 72, 74, 76, 78, 80, 82, 84, 86, 88, 90, 91, 92, 94, 96, 98, 102, 104, 106, 108, 110, 112, 114, 116, 118, 120, 122, 124, 126, 128, 206, 210, 222, 226, 238, 242, 257, 258, 259, 265, 266, 267, 270, 274, 278, 281, 282, 283, 286, 290, 294, 297, 298, 299, 302, 306, 310, 313, 314, 315, 318, 320, 322, 329, 330, 331, 334, 338, 342, 345, 346, 347, 350, 354, 358, 361, 362, 363, 366, 370, 374, 376, 378, 380, 382, 384, 386, 388, 390, 392, 394, 396, 398, 400, 402, 406, 408, 410, 414, 418, 422, 426, 430, 434, 438, 442, 446, 450, 454, 458, 459, 461, 462, 466, 470, 478, 482, 486, 490, 491, 494, 498, 500, 502, 506, 510, 514, 518, 522, 526, 529, 530, 534, 536, 538, 540, 542, 544, 546, 548, 550, 552, 554, 556, 560, 562, 564, 566, 568, 572, 576, 578, 580, 582, 584, 588, 592, 628, 636, 640, 644, 648, 652, 656, 676], percussion: [-13, 6, 22, 72, 80, 88, 96, 104, 112, 136, 144, 152, 160, 168, 176, 184, 192, 200, 208, 216, 224, 232, 240, 248, 256, 264, 272, 280, 288, 296, 304, 312, 320, 328, 336, 344, 352, 360, 368, 408, 416, 424, 432, 440, 448, 456, 464, 472, 480, 488, 496, 504, 512, 520, 528, 600, 608, 616, 624, 676], bass: [4, 6, 20, 22, 36, 38, 52, 54, 68, 70, 84, 86, 92, 94, 96, 98, 100, 102, 112, 116, 118, 122, 124, 126, 128, 130, 132, 134, 138, 140, 142, 146, 150, 154, 155, 158, 162, 166, 170, 174, 178, 182, 186, 187, 189, 190, 194, 198, 202, 206, 210, 212, 214, 218, 219, 222, 226, 230, 234, 238, 242, 246, 250, 251, 253, 254, 257, 258, 259, 260, 261, 262, 266, 267, 270, 274, 278, 282, 283, 286, 290, 292, 294, 298, 302, 306, 308, 310, 314, 318, 322, 326, 327, 330, 334, 338, 342, 346, 350, 354, 358, 362, 366, 370, 372, 374, 378, 380, 382, 386, 388, 390, 392, 394, 396, 398, 400, 402, 404, 406, 410, 414, 418, 420, 422, 426, 430, 434, 438, 442, 446, 450, 454, 458, 459, 461, 462, 466, 470, 474, 478, 482, 486, 490, 491, 494, 498, 502, 506, 510, 514, 518, 522, 523, 525, 526, 529, 530, 531, 532, 534, 564, 566, 580, 582, 598, 602, 606, 610, 614, 618, 622, 626, 628, 660] } };
    }
  });

  // lib/dealer-film/onsets.js
  var require_onsets2 = __commonJS({
    "lib/dealer-film/onsets.js"(exports, module) {
      "use strict";
      var grid = require_grid();
      var data = require_onsets();
      var S16 = grid.BEAT / 4;
      function hitsIn(stems, t0, t1) {
        var seen = {};
        var out = [];
        stems.forEach(function(name) {
          (data.stems[name] || []).forEach(function(k) {
            var t = grid.FIRST_BAR + k * S16;
            if (t >= t0 && t < t1 && !seen[k]) {
              seen[k] = true;
              out.push(t);
            }
          });
        });
        return out.sort(function(a, b) {
          return a - b;
        });
      }
      module.exports = {
        S16,
        hitsIn
      };
    }
  });

  // lib/dealer-film/script.js
  var require_script = __commonJS({
    "lib/dealer-film/script.js"(exports, module) {
      "use strict";
      var grid = require_grid();
      var hitsIn = require_onsets2().hitsIn;
      var b = grid.barStart;
      var beatAt = grid.beatAt;
      function stems() {
        return { stems: Array.prototype.slice.call(arguments) };
      }
      function beats(bars, ns) {
        return bars.reduce(function(a, bar) {
          return a.concat(ns.map(function(n) {
            return beatAt(bar, n);
          }));
        }, []);
      }
      var SPEC = [
        ["v01", 0, "drop", [], null],
        ["v02", b(1), "stamp", ["since"], "since", stems("keys")],
        ["v03", b(2), "window", ["real_people"], "real_people"],
        ["v04", b(3), "split3", ["years"], "years", stems("synth")],
        ["v05", b(4), "counter", ["accounts"], "accounts", stems("keys", "percussion")],
        ["v06", b(5), "ratio", ["repeat"], "repeat"],
        ["v07", b(6), "words", ["word_1", "word_2", "word_3"], "word_1", beats([6], [1, 2, 3])],
        // v08's big line is the flipping size; "219 sizes" is its support (v15 restates it as focal).
        ["v08", b(7), "cascade", ["sizes", "cascade_size"], "cascade_size", stems("brass")],
        ["v09", b(8), "settle", ["cascade_size"], "cascade_size", stems("brass")],
        ["v10", b(9), "price", ["ct_cheapest"], "ct_cheapest"],
        ["v11", b(10), "margin", ["margin_tire"], "margin_tire"],
        ["v12", b(11), "margin4", ["margin_set"], "margin_set"],
        ["v13", b(12), "margin16", ["margin_16"], "margin_16"],
        ["v14", b(13), "carousel", ["carousel"], "carousel", beats([13, 14, 15, 16], [2, 4])],
        ["v15", b(17), "shatter", ["sizes"], "sizes", stems("bass")],
        ["v16", b(18), "cells", ["in_stock"], "in_stock", stems("drums", "percussion")],
        ["v17", b(19), "groups4", ["set4"], "set4"],
        ["v18", b(20), "groups16", ["set16"], "set16"],
        ["v19", b(21), "collapse", ["on_shelf"], "on_shelf"],
        ["v20", b(22), "split3count", ["wh_split"], "wh_split", beats([22], [2, 3, 4])],
        ["v21", b(23), "winter", ["winter"], "winter", stems("drums", "percussion")],
        ["v22", b(24), "gather", ["how_fast"], "how_fast"],
        ["v23", b(25), "rest", [], null],
        ["v24", b(26), "doors", ["warehouses"], "warehouses", beats([26, 27], [2, 4])],
        ["v25", b(28), "hours", ["hours"], "hours", beats([28, 29], [2, 4])],
        ["v26", b(30), "map", ["zones"], "zones", stems("drums")],
        ["v27", b(31), "routes", ["cities"], "cities", stems("drums")],
        ["v28", b(32), "ticker", ["orders_day"], "orders_day", stems("drums")],
        ["v29", b(33), "clock", ["order_before", "qualifier"], "order_before"],
        ["v30", b(34), "clock", [], null],
        ["v31", b(35), "freeze", ["frozen_time"], "frozen_time"],
        ["v32", b(36), "sameDay", ["same_day", "same_day_fallback", "qualifier"], "same_day"],
        ["v33", b(37), "depart", [], null],
        ["v34", b(38), "delivered", ["delivered", "qualifier"], "delivered"],
        // ponytail: measured PEAK (78.47) is 0.022 s off-grid, so the card cuts on the grid beat (Ruling 6).
        ["v35", beatAt(39, 4), "peak", ["peak_margin"], "peak_margin"],
        ["v36", b(40), "tiers", ["tiers"], "tiers", beats([40], [1, 2, 3, 4])],
        ["v37", b(41), "wall", ["team"], "team", stems("keys")],
        ["v38", beatAt(42, 2), "button", ["cta"], "cta"],
        // The tail holds the button, so the film ends on the CTA (constraints: "ends holding the final frame").
        ["v39", beatAt(42, 4), "hold", ["cta"], "cta"]
      ];
      var CUES = SPEC.map(function(s, i) {
        var end = i + 1 < SPEC.length ? SPEC[i + 1][1] : grid.DURATION;
        var cue = { id: s[0], start: s[1], end, kind: s[2], copy: s[3], focal: s[4] };
        if (s[5]) cue.hits = s[5].stems ? hitsIn(s[5].stems, s[1], end) : s[5];
        return cue;
      });
      var COPY_KEYS = CUES.reduce(function(all, c) {
        c.copy.forEach(function(k) {
          if (all.indexOf(k) < 0) all.push(k);
        });
        return all;
      }, []);
      function validateCues(cues) {
        var errors = [];
        if (!Array.isArray(cues) || cues.length === 0) return ["cues must be a non-empty array"];
        if (cues[0].start !== 0) errors.push("first cue must start at 0");
        if (cues[cues.length - 1].end !== grid.DURATION) errors.push("last cue must end at DURATION");
        cues.forEach(function(c, i) {
          if (!(c.end > c.start)) errors.push(c.id + " must end after it starts");
          if (!grid.isOnGrid(c.start)) errors.push(c.id + " start is off the beat grid");
          if (c.focal === "qualifier") errors.push(c.id + " qualifier is support, never focal");
          if (c.focal !== null && c.copy.indexOf(c.focal) < 0) errors.push(c.id + " focal is not one of its copy keys");
          if (c.focal === null && c.copy.length) errors.push(c.id + " has copy but no focal");
          (c.hits || []).forEach(function(h, j) {
            if (!grid.isOn16(h)) errors.push(c.id + " hit " + h + " is off the 1/16 grid");
            if (h < c.start || h >= c.end) errors.push(c.id + " hit " + h + " is outside the cue");
            if (j > 0 && !(h > c.hits[j - 1])) errors.push(c.id + " hits are not sorted");
          });
          if (i > 0 && cues[i - 1].end !== c.start) errors.push(c.id + " leaves a gap or overlap");
        });
        return errors;
      }
      function cueAt(t) {
        for (var i = CUES.length - 1; i > 0; i--) {
          if (t >= CUES[i].start) return CUES[i];
        }
        return CUES[0];
      }
      module.exports = { CUES, COPY_KEYS, validateCues, cueAt };
    }
  });

  // lib/dealer-film/kinds-open.js
  var require_kinds_open = __commonJS({
    "lib/dealer-film/kinds-open.js"(exports, module) {
      "use strict";
      var K = require_kit();
      var grid = require_grid();
      var data = require_data();
      var script = require_script();
      var OM = K.OM;
      var ease = K.ease;
      var BEAT = K.BEAT;
      var R = K.R;
      var copy = K.copy;
      var fadeIn = K.fadeIn;
      function barsFor(P, row) {
        var c = P.chart;
        var hd = c.H * ((row.ct - row.save) / row.ct);
        return {
          ct: R(c.x0, c.base - c.H, c.bw, c.H),
          dealer: R(c.x0 + c.bw + c.gap, c.base - hd, c.bw, hd)
        };
      }
      var LAND = { sqx: 0.25, sqy: 0.3 };
      var HOP = 0.2;
      var COLLAPSE = 0.05;
      var FILE = 0.1;
      var FOLD = 0.3;
      var SWARM_SEED = 20261021;
      var YEARS = [2013, 2021, 2024];
      function warehouses(P) {
        var s = 0.8 * P.dot.w;
        var a = P.axis;
        var span = a.w - s;
        return YEARS.map(function(y) {
          return R(a.x + span * (y - YEARS[0]) / (YEARS[2] - YEARS[0]), a.y - s, s, s);
        });
      }
      var swarmCache = { key: null, rects: null };
      function swarmLayout(P) {
        var key = [P.stage.x, P.stage.y, P.stage.w, P.stage.h].join();
        if (swarmCache.key !== key) swarmCache = { key, rects: buildSwarm(P) };
        return swarmCache.rects;
      }
      function buildSwarm(P) {
        var A = P.swarm;
        var s = P.square.w / 10 * 0.55;
        var cw = A.w / 10;
        var ch = A.h / 10;
        var rnd = OM.rng(SWARM_SEED);
        var out = [];
        for (var i = 0; i < 100; i++) {
          var cx = A.x + (i % 10 + 0.5 + (rnd() - 0.5) * 0.8) * cw;
          var cy = A.y + (Math.floor(i / 10) + 0.5 + (rnd() - 0.5) * 0.8) * ch;
          out.push(R(OM.clamp(cx - s / 2, A.x, A.x + A.w - s), OM.clamp(cy - s / 2, A.y, A.y + A.h - s), s, s));
        }
        return out;
      }
      var homeCache = { key: null, home: null };
      function homeBlock(P, n) {
        var key = [P.stage.x, P.stage.y, P.stage.w, P.stage.h, n].join();
        if (homeCache.key !== key) homeCache = { key, home: buildHome(P, n) };
        return homeCache.home;
      }
      function homeGrid(n) {
        for (var r = Math.floor(Math.sqrt(n)); r >= 1; r--) {
          if (n % r === 0) {
            if (n / r / r <= 1.6) return [n / r, r];
            break;
          }
        }
        var c = Math.ceil(Math.sqrt(n));
        return [c, Math.ceil(n / c)];
      }
      function buildHome(P, n) {
        var sw = swarmLayout(P);
        var s = sw[0].w;
        var p = 1.2 * s;
        var g = homeGrid(n);
        var cols = g[0];
        var a = P.axis;
        var w = cols * p - p + s;
        var h = g[1] * p - p + s;
        var box = R(a.x + (a.w - w) / 2, a.y - h, w, h);
        var slots = [];
        for (var k = 0; k < n; k++) slots.push(R(box.x + k % cols * p, a.y - s - Math.floor(k / cols) * p, s, s));
        var d = function(r) {
          return Math.hypot(r.x + r.w / 2 - box.x - w / 2, r.y + r.h / 2 - box.y - h / 2);
        };
        var order = sw.map(function(r, i) {
          return i;
        }).sort(function(i, j) {
          return d(sw[i]) - d(sw[j]) || i - j;
        });
        var byX = function(rs) {
          return function(i, j) {
            return rs[i].x - rs[j].x || rs[j].y - rs[i].y || i - j;
          };
        };
        var wave = sw.map(function() {
          return -1;
        });
        var slot = [];
        for (var b = 0; b < 4; b++) {
          var lo = K.batch(b - 1, 4, n);
          var hi = K.batch(b, 4, n);
          var who = order.slice(lo, hi).sort(byX(sw));
          var where = slots.map(function(r, m) {
            return m;
          }).slice(lo, hi).sort(byX(slots));
          who.forEach(function(i, m) {
            wave[i] = b;
            slot[i] = slots[where[m]];
          });
        }
        return { box, wave, slot };
      }
      function inFrame(r, B, F) {
        var sx = F.w / B.w;
        var sy = F.h / B.h;
        return R(F.x + (r.x - B.x) * sx, F.y + (r.y - B.y) * sy, r.w * sx, r.h * sy);
      }
      function shareCell(P, i, sq) {
        var c = K.cell(sq || P.square, 10, 10, i);
        var g = c.w * 0.08;
        return R(c.x + g / 2, c.y + g / 2, c.w - g, c.h - g);
      }
      function drop(t, cue, P) {
        var t0 = grid.FIRST_BAR - BEAT;
        return { block: K.morph(t, t0, BEAT, P.top, P.dot, function(u) {
          return u * u;
        }), opacity: t >= t0 ? 1 : 0, copy: [] };
      }
      function stamp(t, cue, P) {
        var j = K.hitIndex(t, cue.hits);
        var block = j < 0 ? K.squash(P.dot, t, cue.start, "bottom", LAND) : K.squash(P.dot, t, cue.hits[j], "bottom", { sqx: 0.06, sqy: 0.09, min: K.accentMin(P) });
        return { block, copy: copy([], "since", fadeIn(t, cue.start, 0.15)) };
      }
      function windowCue(t, cue, P) {
        var block = K.morph(t, cue.start, 0.5, P.dot, P.window);
        var out = grid.beatAt(2, 4);
        var f = { block, copy: copy([], "real_people", fadeIn(t, cue.start + 0.1)) };
        var op = fadeIn(t, cue.start, 0.4) * (1 - OM.seg(t, out, out + BEAT));
        if (op > 0) f.photo = { id: "staff-window", clip: block, opacity: op };
        return f;
      }
      function split3(t, cue, P) {
        var wh = warehouses(P);
        var j = OM.clamp(K.hitIndex(t, cue.hits), 0, 2);
        var later = cue.hits.slice(3);
        var pieces = [];
        for (var i = 0; i <= j; i++) {
          var r;
          if (i === 0) {
            r = K.morph(t, cue.start, HOP, P.window, wh[0]);
          } else {
            var t0 = cue.hits[i];
            var h = OM.hop(t, t0, t0 + HOP, wh[i - 1], wh[i], { height: wh[i].h * 0.8 });
            r = K.squash(R(h.x, h.y, wh[i].w, wh[i].h), t, t0 + HOP, "bottom", { sqx: 0.12, sqy: 0.15 });
          }
          pieces.push(K.piece(K.accent(r, t, later, "bottom", { sqx: 0.04, sqy: 0.06, min: K.accentMin(P) }), "blue"));
        }
        var a = P.axis;
        pieces.push(K.piece(R(a.x, a.y, a.w * fadeIn(t, cue.start, 0.3), a.h), "grey"));
        return { block: wh[j], opacity: 0, pieces, copy: copy([], "years", fadeIn(t, cue.start + 0.05, 0.15)) };
      }
      function counter(t, cue, P, snap) {
        var j = K.hitIndex(t, cue.hits);
        var N = cue.hits.length;
        var n = j === N - 1 ? snap.accounts : Math.round(snap.accounts * ease.cubicOut((j + 1) / N));
        var wh = warehouses(P);
        var sw = swarmLayout(P);
        var last = cue.hits[N - 1];
        var fly = function(h) {
          return Math.min(0.4, cue.end - 0.02 - h);
        };
        var pieces = wh.map(function(r, i2) {
          return K.piece(t < last ? K.accent(r, t, cue.hits, "bottom", { sqx: 0.06, sqy: 0.08, min: K.accentMin(P) }) : K.morph(t, last, fly(last), r, sw[i2]), "blue");
        });
        for (var k = 0; k <= j; k++) {
          for (var i = 3 + K.batch(k - 1, N, 97); i < 3 + K.batch(k, N, 97); i++) {
            var src = wh[i % 3];
            var s = sw[i];
            pieces.push(K.piece(K.morph(t, cue.hits[k], fly(cue.hits[k]), R(src.x + (src.w - s.w) / 2, src.y + (src.h - s.h) / 2, s.w, s.h), s), "blue"));
          }
        }
        var axis = 1 - fadeIn(t, cue.start, 0.2);
        if (axis > 0) pieces.push(K.piece(P.axis, "grey", axis));
        return { block: P.dot, opacity: 0, pieces, copy: j < 0 ? [] : copy([], "accounts", 1, K.num(n)) };
      }
      function ratio(t, cue, P) {
        var n = P.dv.repeatRound;
        var H = homeBlock(P, n);
        var land = cue.start + FILE;
        var F = K.within(K.squash(H.box, t, land, "bottom", OVERSHOOT), P.stage);
        var pieces = swarmLayout(P).map(function(r, i) {
          if (H.wave[i] < 0) return K.piece(r, t >= land ? "pale" : "blue");
          return K.piece(K.morph(t, cue.start + H.wave[i] * BEAT, FILE, r, inFrame(H.slot[i], H.box, F)), "blue");
        });
        return { block: P.dot, opacity: 0, pieces, copy: copy([], "repeat", fadeIn(t, cue.start + 0.1), K.pct(n)) };
      }
      var RING_PEAK = K.RING_PEAK;
      function kick(r, t, times, grow) {
        var j = K.hitIndex(t, times);
        if (j < 0 || t - times[j] > 1) return r;
        var g = grow * Math.max(0, OM.impact(t, times[j]).r) / RING_PEAK;
        return R(r.x, r.y - g, r.w, r.h + g);
      }
      function words(t, cue, P) {
        var list = [];
        var h = cue.hits;
        h.forEach(function(x, i) {
          copy(list, cue.copy[i], t >= x ? 1 : 0);
        });
        var g = Math.max(0.2 * P.line.h, accentPx(P));
        if (t >= h[2]) {
          var shop = K.storefront(P.shop, "blue");
          var from = kick(P.line, h[2], h.slice(0, 2), g);
          var folded = t >= h[2] + FOLD ? shop : shop.map(function(p) {
            return K.piece(K.morph(t, h[2], FOLD, from, p), "blue");
          });
          return { block: P.shop, opacity: 0, pieces: folded, copy: list };
        }
        var line = kick(P.line, t, h.slice(0, 2), g);
        var t1 = cue.start + COLLAPSE;
        if (t >= t1) return { block: line, copy: list };
        var n = P.dv.repeatRound;
        var H = homeBlock(P, n);
        var fade = 1 - OM.seg(t, cue.start, t1);
        var pieces = swarmLayout(P).map(function(r, i) {
          return H.wave[i] >= 0 ? K.piece(K.morph(t, cue.start, COLLAPSE, H.slot[i], line), "blue") : K.piece(K.morph(t, cue.start, COLLAPSE, r, line), "pale", fade);
        });
        return { block: line, opacity: 0, pieces, copy: list };
      }
      var V08 = cueById("v08");
      var V09 = cueById("v09");
      var STABS = V08.hits.concat(V09.hits);
      var HERO = STABS.length - 1;
      var LAST_STAB = STABS[HERO];
      var HELD = [1, 2, 3].map(function(k) {
        return V09.start + k * BEAT;
      }).filter(function(b) {
        return b > LAST_STAB + 1e-6;
      });
      var STRIKE = 0.06;
      var HERO_STRIKE = 0.04;
      var LANDED = STABS.map(function(h, k) {
        return h + (k === HERO ? HERO_STRIKE : STRIKE);
      });
      var SIDE = 3 * K.S16;
      var SEG = 0.16;
      var ARC = 6;
      var ZOOM = 1.6;
      var PUSH = 6;
      var PUSH_AT = LAST_STAB + 2 * K.S16;
      var LEAD_IN = STABS[1];
      var LABEL_OUT = 0.55;
      var STROKES = [2.5, 1.75, 1.25, 1, 0.75];
      var SIDE_AT = 1.3;
      var SIDE_LEN = 1;
      var FAN = 0.5;
      var UP = [-Math.PI + 0.15, -0.15];
      var PATH_UP = [-2.2, -0.4];
      function cueById(id) {
        return script.CUES.filter(function(c) {
          return c.id === id;
        })[0];
      }
      function sideTips(n, k) {
        var m = n - 1;
        return Math.floor(m * (k + 1) / HERO) - Math.floor(m * k / HERO);
      }
      function riverSegCount(n) {
        var c = STABS.length;
        for (var k = 0; k < HERO; k++) c += Math.max(0, 2 * sideTips(n, k) - 1);
        return c;
      }
      var pathCache = { key: null, path: null };
      function riverPath(P, n) {
        var key = [P.stage.x, P.stage.y, P.stage.w, P.stage.h, n].join();
        if (pathCache.key !== key) pathCache = { key, path: buildPath(P, n) };
        return pathCache.path;
      }
      function buildPath(P, n) {
        var u = Math.min(P.stage.w, P.stage.h);
        var L = SEG * u;
        var rnd = OM.rng(SWARM_SEED);
        var segs = [];
        var tips = [];
        var arc = function(q, a2, len, lim) {
          var bend = (rnd() - 0.5) * 0.9 / (ARC - 1);
          var pts = [q];
          for (var i = 1; i < ARC; i++) {
            a2 = OM.clamp(a2 + bend, lim[0], lim[1]);
            q = { x: q.x + Math.cos(a2) * len / (ARC - 1), y: q.y + Math.sin(a2) * len / (ARC - 1) };
            pts.push(q);
          }
          return { pts, a: a2 };
        };
        var side = function(q, a2, len, depth, t0, leaves, lim) {
          var s = arc(q, a2, len, lim);
          var end = s.pts[ARC - 1];
          segs.push({ pts: s.pts, depth, t0, dur: SIDE, dot: leaves === 1 });
          if (leaves === 1) return tips.push(end);
          var spread = 0.35 + 0.45 * rnd();
          var half = Math.ceil(leaves / 2);
          side(end, s.a - spread, 0.72 * len, depth + 1, t0 + SIDE, half, lim);
          side(end, s.a + spread, 0.72 * len, depth + 1, t0 + SIDE, leaves - half, lim);
        };
        var at = { x: P.shop.x + P.shop.w / 2, y: P.shop.y };
        var path = [at];
        var forks = [];
        var a = -1.15;
        STABS.forEach(function(h, k) {
          var m = arc(at, OM.clamp(a + (rnd() - 0.5) * 0.5, PATH_UP[0], PATH_UP[1]), L, PATH_UP);
          segs.push({ pts: m.pts, depth: 0, t0: h, dur: LANDED[k] - h, dot: true });
          path = path.concat(m.pts.slice(1));
          at = m.pts[ARC - 1];
          var dir = k % 2 ? 1 : -1;
          var sa = OM.clamp(m.a + dir * (SIDE_AT + 0.3 * rnd()), UP[0], UP[1]);
          forks.push({ x: at.x, y: at.y, i: k, side: Math.cos(sa) < 0 ? -1 : 1 });
          if (k < HERO && sideTips(n, k) > 0) side(at, sa, SIDE_LEN * L, 1, h + K.S16, sideTips(n, k), [Math.max(UP[0], sa - FAN), Math.min(UP[1], sa + FAN)]);
          a = m.a + (k % 2 ? 0.35 : -0.35);
        });
        tips.push(at);
        segs = segs.map(function(s, i) {
          return [s, i];
        }).sort(function(x, y) {
          return x[0].t0 - y[0].t0 || x[1] - y[1];
        }).map(function(x) {
          return x[0];
        });
        return { path, forks, segs, tips, d: Math.max(4, Math.round(0.025 * u)) };
      }
      function lerpPt(a, b, u) {
        return { x: a.x + (b.x - a.x) * u, y: a.y + (b.y - a.y) * u };
      }
      function followCam(t, P, V) {
        var S = P.stage;
        var v = P.view;
        var F = V.forks;
        var mid = function(k2) {
          return lerpPt(k2 < 0 ? V.path[0] : F[k2], F[k2 + 1], 0.5);
        };
        var k = Math.max(0, K.hitIndex(t, STABS));
        var q = k < HERO ? lerpPt(mid(k - 1), mid(k), OM.seg(t, STABS[k], STABS[k + 1])) : lerpPt(mid(HERO - 1), F[HERO], ease.cubicInOut(OM.seg(t, LAST_STAB, PUSH_AT)));
        var z = ZOOM * Math.pow(PUSH / ZOOM, ease.cubicInOut(OM.seg(t, PUSH_AT, V09.end)));
        var e = ease.cubicInOut(OM.seg(t, V08.start, LEAD_IN));
        var cx = q.x - (S.x + S.w / 2 - v.w / 2) / z;
        var cy = q.y - (S.y + S.h / 2 - v.h / 2) / z;
        return { x: v.w / 2 + (cx - v.w / 2) * e, y: v.h / 2 + (cy - v.h / 2) * e, zoom: Math.pow(z, e), rot: 0 };
      }
      function cutTo(r, W, tone) {
        var x0 = Math.max(r.x, W.x);
        var y0 = Math.max(r.y, W.y);
        var x1 = Math.min(r.x + r.w, W.x + W.w);
        var y1 = Math.min(r.y + r.h, W.y + W.h);
        if (x1 > x0 && y1 > y0) return K.piece(R(x0, y0, x1 - x0, y1 - y0), tone);
        return K.piece(R(OM.clamp(r.x, W.x, W.x + W.w), OM.clamp(r.y, W.y, W.y + W.h), 0, 0), tone, 0);
      }
      function swell(r, t, times, g) {
        var j = K.hitIndex(t, times);
        if (j < 0 || t - times[j] > 1) return r;
        var e = g * Math.max(0, OM.impact(t, times[j]).r) / RING_PEAK;
        return R(r.x - e / 2, r.y - e / 2, r.w + e, r.h + e);
      }
      function stabSize(P, snap, m) {
        var others = snap.cascade.filter(function(s) {
          return s !== P.hero.size;
        });
        return m === HERO || !others.length ? P.hero.size : others[m % others.length];
      }
      function river(t, P, snap) {
        var sizes = data.riverSizes(snap);
        var V = riverPath(P, sizes.length);
        var cam = followCam(t, P, V);
        var z = cam.zoom;
        var S = P.stage;
        var v = P.view;
        var W = R(cam.x + (S.x - v.w / 2) / z, cam.y + (S.y - v.h / 2) / z, S.w / z, S.h / z);
        var k = K.hitIndex(t, STABS);
        var branches = [];
        var head = null;
        for (var i = 0; i < V.segs.length && V.segs[i].t0 <= Math.min(t, LAST_STAB); i++) {
          var s = V.segs[i];
          var p = ease.cubicOut(OM.seg(t, s.t0, s.t0 + s.dur));
          var trunk = s.depth === 0 && s.t0 === LAST_STAB;
          var blue = trunk || t < LAST_STAB && t < s.t0 + Math.max(s.dur, K.S16) + K.S16 / 2;
          branches.push({ pts: s.pts, p, tone: blue ? "blue" : "grey", w: STROKES[Math.min(s.depth, STROKES.length - 1)], depth: s.depth, dot: s.dot });
          if (s.depth === 0 && p > 0) head = K.drawn(branches[branches.length - 1]).pop();
        }
        var pieces = K.storefront(P.shop, "blue").map(function(r2) {
          return cutTo(r2, W, "blue");
        });
        if (head) {
          var d = V.d;
          var r = R(head.x - d / 2, head.y - d / 2, d, d);
          r = K.hitIndex(t, HELD) < 0 ? swell(r, t, STABS, K.accentMin(P) / z) : swell(r, t, HELD, K.HOLD_TICK / z);
          pieces.push(cutTo(r, W, "blue"));
        }
        var labels = [];
        for (var j = 0; j <= k; j++) {
          var li = sizes.indexOf(stabSize(P, snap, j));
          var newest = j === k;
          var out = j + 2 < STABS.length ? STABS[j + 2] : STABS[j + 1] + K.S16;
          var op = newest ? OM.seg(t, STABS[j], LANDED[j]) : t < out ? 1 : 0.45 * (1 - OM.seg(t, out, out + LABEL_OUT));
          if (li < 0 || !(op > 0)) continue;
          var f = V.forks[j];
          var gap = V.d / 2 + 6 / z;
          var left = j === HERO || f.side > 0;
          labels.push({ i: li, x: left ? f.x - gap : f.x + gap, y: f.y, opacity: op, hot: newest, right: left });
        }
        return { block: P.shop, opacity: 0, pieces, branches, labels, camera: cam };
      }
      function sizeLine(list, t, P, snap) {
        var j = K.hitIndex(t, STABS);
        return j < 0 ? list : copy(list, "cascade_size", 1, { size: stabSize(P, snap, j) });
      }
      function cascade(t, cue, P, snap) {
        var f = river(t, P, snap);
        f.copy = sizeLine(copy([], "sizes", fadeIn(t, cue.start, 0.15), K.values("sizes", P, snap)), t, P, snap);
        return f;
      }
      function settle(t, cue, P, snap) {
        var f = river(t, P, snap);
        f.copy = sizeLine([], t, P, snap);
        return f;
      }
      var SLAM = 0.05;
      var OVERSHOOT = { sqx: -0.1, sqy: -0.25 };
      var STEP = 0.3;
      function accentPx(P) {
        return Math.max(K.ACCENT_FLOOR, 0.04 * P.stage.h);
      }
      function gapOf(b) {
        return R(b.dealer.x, b.ct.y, b.dealer.w, b.dealer.y - b.ct.y);
      }
      function hover(P) {
        var g = gapOf(barsFor(P, P.hero));
        var s = P.stackBase;
        return R(s.x + (s.w - g.w) / 2, s.y - 0.06 * P.stage.h - g.h, g.w, g.h);
      }
      function slabs(P) {
        return K.stackRects(P.stackBase, 4, 1, P.layer.h, P.layer.gap);
      }
      function tower(P) {
        var L = P.layer;
        return K.stackRects(P.stackBase, 16, 4, 4 * L.h + 3 * L.gap, L.gap);
      }
      function chartRows(P) {
        return [P.hero].concat(P.carousel.filter(function(r) {
          return r !== P.hero;
        })).slice(0, 8);
      }
      function namedBar(n, j) {
        return j < 0 || n < 2 ? 0 : 1 + j % (n - 1);
      }
      function chartRow(P, j) {
        var rows = chartRows(P);
        return rows[namedBar(rows.length, j)];
      }
      function chart(P) {
        var rows = chartRows(P);
        var s = P.stackBase;
        var gap = s.w * 0.04;
        var w = (s.w - (rows.length - 1) * gap) / rows.length;
        var unit = P.chart.H / P.hero.ct;
        return rows.map(function(r, i) {
          var h = unit * r.save;
          return R(s.x + i * (w + gap), s.y - h, w, h);
        });
      }
      function price(t, cue, P, snap) {
        var b = barsFor(P, P.hero);
        var tg = P.tag;
        var half = function(i) {
          return R(tg.x + i * tg.w / 2, tg.y, tg.w / 2, tg.h);
        };
        var fall = function(u) {
          return u * u;
        };
        var dealer = K.squash(K.morph(t, cue.start, SLAM, half(1), b.dealer, fall), t, cue.start, "bottom", OVERSHOOT);
        dealer = kick(dealer, t, [1, 2, 3].map(function(k) {
          return cue.start + k * BEAT;
        }), accentPx(P));
        var ct = K.squash(K.morph(t, cue.start, SLAM, half(0), b.ct, fall), t, cue.start, "bottom", { sqx: 0.06, sqy: 0.08 });
        return {
          block: dealer,
          bars: { ct, dealer, tone: { ct: "grey", dealer: "blue" } },
          copy: copy([], "ct_cheapest", fadeIn(t, cue.start + 0.1), K.values("ct_cheapest", P, snap))
        };
      }
      function margin(t, cue, P, snap) {
        var b = barsFor(P, P.hero);
        var gap = gapOf(b);
        var to = hover(P);
        var path = [
          R(gap.x, b.dealer.y, gap.w, 0),
          gap,
          R(gap.x, gap.y - 0.06 * P.stage.h, gap.w, gap.h),
          R(to.x, gap.y - 0.06 * P.stage.h, gap.w, gap.h),
          to
        ];
        var k = Math.min(3, K.beatOf(t, cue));
        var m = K.morph(t, cue.start + k * BEAT, STEP, path[k], path[k + 1], k ? ease.backOut : void 0);
        var f = { block: m, opacity: 0, pieces: [K.piece(m, "blue")], copy: copy([], "margin_tire", fadeIn(t, cue.start + 0.1), K.values("margin_tire", P, snap)) };
        if (k < 3) f.bars = { ct: b.ct, dealer: b.dealer, tone: { ct: "grey", dealer: k < 2 ? "blue" : "grey" } };
        return f;
      }
      function margin4(t, cue, P, snap) {
        var s = slabs(P);
        var n = Math.min(4, K.beatOf(t, cue) + 1);
        var pieces = [];
        for (var k = 0; k < n; k++) {
          var t0 = cue.start + k * BEAT;
          var r = k === 0 ? kick(K.morph(t, t0, SLAM, hover(P), s[0], function(u) {
            return u * u;
          }), t, [t0 + SLAM], accentPx(P)) : K.morph(t, t0, STEP, s[k - 1], s[k], ease.backOut);
          pieces.push(K.piece(r, "blue"));
        }
        return { block: pieces[n - 1], opacity: 0, pieces, copy: copy([], "margin_set", fadeIn(t, cue.start + 0.05), K.values("margin_set", P, snap)) };
      }
      function margin16(t, cue, P, snap) {
        var s = slabs(P);
        var T = tower(P);
        var rows = Math.min(4, K.beatOf(t, cue) + 1);
        var pieces = [];
        for (var i = 0; i < 4 * rows; i++) {
          var r = Math.floor(i / 4);
          pieces.push(K.piece(r ? K.morph(t, cue.start + r * BEAT, STEP, T[i - 4], T[i], ease.backOut) : K.morph(t, cue.start, STEP, s[i], T[i]), "blue"));
        }
        return { block: pieces[pieces.length - 1], opacity: 0, pieces, copy: copy([], "margin_16", fadeIn(t, cue.start + 0.05), K.values("margin_16", P, snap)) };
      }
      function carousel(t, cue, P) {
        var j = K.hitIndex(t, cue.hits);
        var bars = chart(P);
        var n = bars.length;
        var row = chartRow(P, j);
        var pieces;
        if (j < 0) {
          var b0 = bars[0];
          var sh = b0.h / 16;
          pieces = tower(P).map(function(r, i) {
            return K.piece(K.morph(t, cue.start, BEAT, r, R(b0.x, b0.y + b0.h - (i + 1) * sh, b0.w, sh), ease.cubicOut), "blue");
          });
        } else {
          pieces = bars.slice(0, Math.min(j + 2, n)).map(function(bar, k) {
            var r = k ? K.morph(t, cue.hits[k - 1], STEP, bars[k - 1], bar, ease.backOut) : bar;
            var mine = cue.hits.filter(function(h, m) {
              return namedBar(n, m) === k;
            });
            return K.piece(kick(r, t, mine, accentPx(P)), "blue");
          });
        }
        var last = chartRow(P, cue.hits.length - 1);
        return { block: barsFor(P, last).dealer, opacity: 0, pieces, copy: copy([], "carousel", fadeIn(t, cue.start, 0.15), K.rowMargin(row)) };
      }
      module.exports = {
        KINDS: {
          drop,
          stamp,
          window: windowCue,
          split3,
          counter,
          ratio,
          words,
          cascade,
          settle,
          price,
          margin,
          margin4,
          margin16,
          carousel
        },
        barsFor,
        swarmLayout,
        chart,
        chartRow,
        kick,
        shareCell,
        homeBlock,
        riverPath,
        riverSegCount,
        accentPx
      };
    }
  });

  // lib/dealer-film/kinds-stock.js
  var require_kinds_stock = __commonJS({
    "lib/dealer-film/kinds-stock.js"(exports, module) {
      "use strict";
      var K = require_kit();
      var script = require_script();
      var open = require_kinds_open();
      var onsets = require_onsets2();
      var OM = K.OM;
      var BEAT = K.BEAT;
      var R = K.R;
      var ease = K.ease;
      var STEP = 0.3;
      var STRETCH = { sqx: -0.1, sqy: -0.25 };
      var copy = K.copy;
      var fadeIn = K.fadeIn;
      function prevCue(cue) {
        return script.CUES[script.CUES.indexOf(cue) - 1];
      }
      function shelf(lit, extra) {
        return Object.assign({ cols: 10, rows: 10, lit }, extra);
      }
      function columnRects(P, values, unit) {
        var s = P.stackBase;
        var gap = s.w * 0.06;
        var w = (s.w - 2 * gap) / 3;
        var u = unit || 0.78 * P.stage.h / Math.max.apply(null, values);
        var x0 = s.x + (s.w - values.length * w - (values.length - 1) * gap) / 2;
        return values.map(function(v, i) {
          var h = u * v;
          return R(x0 + i * (w + gap), s.y - h, w, h);
        });
      }
      function wholeUnit(P, snap) {
        return 0.78 * P.stage.h / snap.tiresOnHand;
      }
      function column(P, snap) {
        return columnRects(P, [snap.tiresOnHand])[0];
      }
      function slice(r, above, h) {
        return R(r.x, r.y + r.h - above - h, r.w, h);
      }
      function band(r, snap, u) {
        var h = u * r.h * snap.winterTires / snap.tiresOnHand;
        return R(r.x, r.y + r.h - h, r.w, h);
      }
      function beats(cue, ks) {
        return ks.map(function(k) {
          return cue.start + k * BEAT;
        });
      }
      function rise(t, cue) {
        return K.ease.cubicOut(OM.seg(K.on16(t), cue.start, cue.start + 2 * BEAT));
      }
      function shatter(t, cue, P, snap) {
        var prev = prevCue(cue);
        var from = open.barsFor(P, open.chartRow(P, prev.hits.length - 1));
        var j = K.hitIndex(t, cue.hits);
        var lit = 100 - K.batch(j, cue.hits.length, 99);
        var t0 = cue.hits[0];
        var t1 = cue.hits[2];
        var f = { copy: copy([], "sizes", fadeIn(t, cue.start + 0.05, 0.15), K.values("sizes", P, snap)) };
        if (t >= t1) {
          f.block = K.within(K.squash(P.square, t, t1, "bottom", STRETCH), P.stage);
          f.grid = shelf(lit);
          return f;
        }
        var bars = open.chart(P);
        var n = bars.length;
        var fall = function(u) {
          return u * u;
        };
        f.block = K.morph(t, cue.start, t1 - cue.start, from.dealer, P.square);
        f.opacity = 0;
        f.pieces = [];
        for (var i = 0; i < 100; i++) {
          var k = Math.floor(i * n / 100);
          var i0 = Math.ceil(k * 100 / n);
          var b = bars[k];
          var sh = b.h / (Math.ceil((k + 1) * 100 / n) - i0);
          var c = (9 - i % 10) * 10 + Math.floor(i / 10);
          var r = K.morph(t, t0, t1 - t0, R(b.x, b.y + b.h - (i - i0 + 1) * sh, b.w, sh), K.cell(P.square, 10, 10, c), fall);
          f.pieces.push(K.piece(r, c < lit ? "blue" : "pale"));
        }
        return f;
      }
      function cells(t, cue, P) {
        var j = K.hitIndex(t, cue.hits);
        var target = P.dv.inStockRound;
        return {
          block: K.accent(P.square, t, cue.hits, "bottom", { sqx: 0.02, sqy: 0.03, min: K.accentMin(P) }),
          grid: shelf(K.batch(j, cue.hits.length, target)),
          copy: copy([], "in_stock", fadeIn(t, cue.start + 0.05, 0.15), K.pct(target))
        };
      }
      function groups(sub, valueKey, copyKey) {
        return function(t, cue, P) {
          var target = P.dv[valueKey];
          return {
            block: K.pulse(P.square, t, cue, 0.02, 0, K.accentMin(P)),
            grid: shelf(target, { sub }),
            copy: copy([], copyKey, fadeIn(t, cue.start + 0.05, 0.15), K.pct(target))
          };
        };
      }
      function collapse(t, cue, P, snap) {
        var dur = 0.35;
        var col = column(P, snap);
        var u = rise(t, cue);
        var h = Math.max(P.layer.h, col.h * u);
        var r = slice(col, 0, h);
        var f = { copy: copy([], "on_shelf", fadeIn(t, cue.start + 0.05, 0.15), K.num(Math.round(snap.tiresOnHand * u))) };
        if (t < cue.start + dur) {
          f.block = K.morph(t, cue.start, dur, P.square, r);
          f.grid = shelf(P.dv.set16Round, { sub: 4 });
          return f;
        }
        r = open.kick(r, t, beats(cue, [3]), open.accentPx(P));
        return Object.assign(f, { block: r, opacity: 0, pieces: [K.piece(r, "blue")] });
      }
      function split3count(t, cue, P, snap) {
        var j = K.hitIndex(t, cue.hits);
        var all = K.values("wh_split", P, snap);
        var vals = {};
        ["oak", "cam", "ny"].slice(0, j + 1).forEach(function(k) {
          vals[k] = all[k];
          vals[k + "Raw"] = all[k + "Raw"];
        });
        var wh = [snap.whOakville, snap.whCambridge, snap.whNorthYork];
        var unit = wholeUnit(P, snap);
        var col = column(P, snap);
        var s1 = columnRects(P, [wh[0], wh[1] + wh[2]], unit);
        var s2 = columnRects(P, wh, unit);
        var go = function(k, A, B, curve) {
          return K.morph(t, cue.hits[k], STEP, A, B, curve);
        };
        var rs;
        if (j < 0) rs = [col];
        else if (j === 0) rs = [go(0, slice(col, 0, s1[0].h), s1[0]), go(0, slice(col, s1[0].h, s1[1].h), s1[1])];
        else if (j === 1) rs = [go(1, s1[0], s2[0]), go(1, slice(s1[1], 0, s2[1].h), s2[1]), go(1, slice(s1[1], s2[1].h, s2[2].h), s2[2])];
        else {
          var fin = columnRects(P, wh);
          rs = s2.map(function(r, i) {
            return go(2, r, fin[i], ease.backOut);
          });
        }
        var pieces = rs.map(function(r) {
          return K.piece(r, "blue");
        });
        return {
          block: rs[rs.length - 1],
          opacity: 0,
          pieces,
          copy: j < 0 ? [] : copy([], "wh_split", 1, vals)
          // a hard cut on beat 2, like a digit flip
        };
      }
      var ZOOM = 0.2;
      var JOIN = 0.25;
      function winter(t, cue, P, snap) {
        var j = K.hitIndex(t, cue.hits);
        var col = column(P, snap);
        var wh = [snap.whOakville, snap.whCambridge, snap.whNorthYork];
        var fin = columnRects(P, wh);
        var s2 = columnRects(P, wh, wholeUnit(P, snap));
        var tj = cue.start + ZOOM;
        var rs;
        if (t < tj) rs = fin.map(function(r, i) {
          return K.morph(t, cue.start, ZOOM, r, s2[i], ease.cubicInOut);
        });
        else if (t < tj + JOIN) rs = s2.map(function(r, i) {
          return K.morph(t, tj, JOIN, r, slice(col, i ? s2[0].h + (i > 1 ? s2[1].h : 0) : 0, r.h));
        });
        else rs = [col];
        var pieces = rs.map(function(r) {
          return K.piece(r, "blue");
        });
        var N = cue.hits.length - 1;
        if (j >= 1) pieces.push(K.piece(K.morph(t, cue.hits[j], STEP, band(col, snap, (j - 1) / N), band(col, snap, j / N), ease.backOut), "navy"));
        return {
          block: rs[rs.length - 1],
          // hidden, carried on from v20's last column
          opacity: 0,
          pieces,
          copy: copy([], "winter", fadeIn(t, cue.start + 0.05, 0.15), K.values("winter", P, snap))
        };
      }
      function shopKick(P, t, times, grow) {
        var pieces = K.storefront(open.kick(P.shop, t, times, grow), "blue");
        return { block: K.blueBox({ pieces }), opacity: 0, pieces };
      }
      function gather(t, cue, P, snap) {
        var t1 = cue.start + BEAT;
        var list = copy([], "how_fast", fadeIn(t, t1, 0.15));
        if (t >= t1) return Object.assign(shopKick(P, t, [t1].concat(onsets.hitsIn(["keys"], t1, cue.end)), open.accentPx(P)), { copy: list });
        var col = column(P, snap);
        var shop = K.storefront(P.shop, "blue");
        var body = shop[0];
        var sink = function(A, B) {
          return K.morph(t, cue.start, BEAT, A, B, ease.cubicInOut);
        };
        var pieces = shop.map(function(p) {
          return K.piece(sink(col, p), "blue");
        });
        pieces.push(K.piece(sink(band(col, snap, 1), R(body.x, body.y + body.h, body.w, 0)), "navy"));
        return { block: K.blueBox({ pieces }), opacity: 0, pieces, copy: list };
      }
      function rest(t, cue, P) {
        var quarters = onsets.hitsIn(["keys"], cue.start, cue.end).filter(function(h) {
          return Math.round((h - cue.start) / K.S16) % 4 === 0;
        });
        return Object.assign(shopKick(P, t, quarters, K.HOLD_TICK), { copy: [] });
      }
      module.exports = {
        KINDS: {
          shatter,
          cells,
          groups4: groups(2, "set4Round", "set4"),
          groups16: groups(4, "set16Round", "set16"),
          collapse,
          split3count,
          winter,
          gather,
          rest
        },
        columnRects
      };
    }
  });

  // lib/dealer-film/kinds-reach.js
  var require_kinds_reach = __commonJS({
    "lib/dealer-film/kinds-reach.js"(exports, module) {
      "use strict";
      var K = require_kit();
      var open = require_kinds_open();
      var OM = K.OM;
      var ease = K.ease;
      var BEAT = K.BEAT;
      var R = K.R;
      var copy = K.copy;
      var fadeIn = K.fadeIn;
      var DOTS_SEED = 20261021;
      var ROUTES = require_script().CUES.filter(function(c) {
        return c.id === "v27";
      })[0].hits.length;
      function zoneDots(P) {
        return layoutFor(P).pts;
      }
      var cache = { key: null, pts: null, routes: null };
      function layoutFor(P) {
        var key = [P.stage.x, P.stage.y, P.stage.w, P.stage.h, P.dv.fsaApprox].join();
        if (cache.key !== key) {
          var pts = buildDots(P);
          cache = { key, pts, routes: routeEnds(P, pts, ROUTES) };
        }
        return cache;
      }
      function buildDots(P) {
        var r = P.map;
        var n = P.dv.fsaApprox;
        var cols = Math.ceil(Math.sqrt(1.3 * n * r.w / r.h));
        var rows = Math.ceil(1.3 * n / cols);
        var cw = r.w / cols;
        var ch = r.h / rows;
        var rnd = OM.rng(DOTS_SEED);
        var pts = [];
        for (var i = 0; i < cols * rows; i++) {
          pts.push({
            x: r.x + (i % cols + 0.5 + (rnd() - 0.5) * 0.7) * cw,
            y: r.y + (Math.floor(i / cols) + 0.5 + (rnd() - 0.5) * 0.7) * ch
          });
        }
        var cx = r.x + r.w / 2;
        var cy = r.y + r.h / 2;
        var d = function(p) {
          var dx = (p.x - cx) / r.w;
          var dy = (p.y - cy) / r.h;
          return dx * dx + dy * dy;
        };
        var wh = warehouseDots(P);
        var off = function(p) {
          return wh.every(function(w) {
            return p.x + 4 <= w.x || p.x - 4 >= w.x + w.w || p.y + 4 <= w.y || p.y - 4 >= w.y + w.h;
          });
        };
        var near = function(p) {
          return Math.min.apply(null, wh.map(function(w) {
            return dist2(p, { x: w.x + w.w / 2, y: w.y + w.h / 2 });
          }));
        };
        return pts.filter(off).sort(function(a, b) {
          return d(a) - d(b);
        }).slice(0, n).sort(function(a, b) {
          return near(a) - near(b);
        });
      }
      function dist2(a, b) {
        return (a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y);
      }
      function routeEnds(P, pts, N) {
        var wh = warehouseDots(P);
        var reach = 0.2 * Math.min(P.map.w, P.map.h);
        var out = [];
        for (var i = 0; i < N; i++) {
          var w = wh[i % 3];
          var a = { x: w.x + w.w / 2, y: w.y + w.h / 2 };
          var th = i * 2.39996;
          var aim = { x: a.x + reach * Math.cos(th), y: a.y + reach * Math.sin(th) };
          var b = pts.reduce(function(best, p) {
            return dist2(aim, p) < dist2(aim, best) ? p : best;
          });
          out.push({ x1: a.x, y1: a.y, x2: b.x, y2: b.y });
        }
        return out;
      }
      function promise(list, key, op, vals) {
        return copy(copy(list, key, op, vals), "qualifier", op);
      }
      var STRETCH = { sqx: -0.1, sqy: -0.25 };
      var SLAM = 0.05;
      function shop(P) {
        return K.storefront(P.shop, "blue");
      }
      function shopBox(P) {
        return K.blueBox({ pieces: shop(P) });
      }
      function faces(offset, key) {
        return function(t, cue, P) {
          var j = K.hitIndex(t, cue.hits);
          var k = offset + j;
          var from = offset ? P.three : K.squash(K.morph(t, cue.start, SLAM, shopBox(P), P.three), t, cue.start, "bottom", STRETCH);
          var block = open.kick(from, t, cue.hits, open.accentPx(P));
          var f = {
            block,
            grid: { cols: 3, rows: 1, lit: 3 },
            copy: copy([], key, fadeIn(t, cue.start + (offset ? 0.05 : 0.15), 0.15))
          };
          if (k >= 0) f.photo = { id: "staff-" + (k + 1), clip: K.cell(block, 3, 1, k % 3), opacity: 1 };
          return f;
        };
      }
      function warehouseDots(P) {
        var s = 0.3 * P.dot.w;
        return [0, 1, 2].map(function(i) {
          var c = K.cell(P.three, 3, 1, i);
          return R(c.x + (c.w - s) / 2, c.y + (c.h - s) / 2, s, s);
        });
      }
      function map(t, cue, P) {
        var pts = zoneDots(P);
        var j = K.hitIndex(t, cue.hits);
        var shrink = function(A, B) {
          return K.morph(t, cue.start, 0.35, A, B);
        };
        return {
          block: shrink(P.three, P.map),
          opacity: 0,
          pieces: warehouseDots(P).map(function(r, i) {
            return K.piece(shrink(K.cell(P.three, 3, 1, i), r), "blue");
          }),
          dots: { pts, lit: K.batch(j, cue.hits.length, pts.length) },
          copy: copy([], "zones", fadeIn(t, cue.start + 0.05, 0.15), K.values("zones", P))
        };
      }
      function routes(t, cue, P) {
        var L = layoutFor(P);
        return {
          block: P.map,
          opacity: 0,
          pieces: warehouseDots(P).map(function(r) {
            return K.piece(r, "blue");
          }),
          dots: { pts: L.pts, lit: L.pts.length },
          // a fresh object per frame: the cached ends are shared, p is this frame's own
          routes: L.routes.map(function(r, i) {
            var h = cue.hits[i];
            return { x1: r.x1, y1: r.y1, x2: r.x2, y2: r.y2, p: ease.cubicOut(OM.seg(t, h, h + Math.min(BEAT, cue.end - h))) };
          }),
          copy: copy([], "cities", fadeIn(t, cue.start + 0.05, 0.15), K.values("cities", P))
        };
      }
      var CHUTE = 0.2;
      var FALL = 0.12;
      function chuteRect(P) {
        var s = 0.3 * P.dot.w;
        var tr = P.tray;
        return R(tr.x + (tr.w - s) / 2, P.stage.y + 0.1 * P.stage.h - s / 2, s, s);
      }
      function chips(P) {
        var tr = P.tray;
        var n = chipCount(P);
        return K.stackRects({ x: tr.x + chipPad(P), y: tr.y + tr.h - chipPad(P), w: tr.w - 2 * chipPad(P) }, n, 1, (tr.h - chipPad(P) - (n - 1)) / n, 1);
      }
      function chipPad(P) {
        return 0.04 * P.tray.w;
      }
      var CHIPS_MAX = 124;
      function chipCount(P) {
        return Math.max(1, Math.min(P.dv.ordersApprox, CHIPS_MAX, Math.floor((P.tray.h - chipPad(P) + 1) / 2)));
      }
      function ticker(t, cue, P) {
        var j = K.hitIndex(t, cue.hits);
        var N = cue.hits.length;
        var n = P.dv.ordersApprox;
        var wh = warehouseDots(P);
        var ch = chuteRect(P);
        var chuteAt = function(u) {
          return K.morph(u, cue.start, CHUTE, wh[1], ch);
        };
        var slots = chips(P);
        var fall = function(u) {
          return u * u;
        };
        var pieces = [K.piece(P.tray, "grey", fadeIn(t, cue.start, BEAT))];
        for (var b = 0; b <= j; b++) {
          for (var i = K.batch(b - 1, N, slots.length); i < K.batch(b, N, slots.length); i++) {
            pieces.push(K.piece(K.morph(t, cue.hits[b], FALL, chuteAt(cue.hits[b]), slots[i], fall), "blue"));
          }
        }
        if (t < cue.start + CHUTE) [0, 2].forEach(function(i2) {
          pieces.push(K.piece(K.morph(t, cue.start, CHUTE, wh[i2], chuteAt(t)), "blue"));
        });
        if (t < cue.hits[N - 1]) pieces.push(K.piece(chuteAt(t), "blue"));
        var f = {
          block: K.morph(t, cue.start, BEAT, P.map, P.tray),
          // hidden, carried from the map to the tray
          opacity: 0,
          pieces,
          // a hard cut on the first hit (the downbeat), like a digit flip, so its value is never hidden
          copy: j < 0 ? [] : copy([], "orders_day", 1, K.num(K.batch(j, N, n)))
        };
        if (t < cue.start + BEAT) f.dots = { pts: zoneDots(P), lit: 0 };
        return f;
      }
      var T29 = require_script().CUES.filter(function(c) {
        return c.id === "v29";
      })[0].start;
      var FOLD = 0.2;
      function minuteAt(t) {
        return Math.min(58, 47 + Math.floor((t - T29) / BEAT + 1e-9));
      }
      function clockFace(P, m, face) {
        var f = P.square;
        var cx = f.x + f.w / 2;
        var cy = f.y + f.h / 2;
        var s = 0.05 * f.w;
        var r0 = f.w / 2;
        var mark = function(a, r) {
          return K.piece(R(cx + r * Math.sin(a) - s / 2, cy - r * Math.cos(a) - s / 2, s, s), "pale");
        };
        var out = [K.piece(face || f, "blue"), mark(0, 0.84 * r0)];
        for (var i = 0; i <= 5; i++) out.push(mark(m / 60 * 2 * Math.PI, i / 5 * 0.7 * r0));
        return out;
      }
      function clock(t, cue, P) {
        var t1 = T29 + FOLD;
        var f = { block: P.square, opacity: 0, copy: cue.copy.length ? promise([], "order_before", fadeIn(t, cue.start + 0.1)) : [] };
        var face = K.within(K.squash(P.square, t, Math.max(cue.start, t1), "bottom", STRETCH), P.stage);
        if (t >= t1) return Object.assign(f, { pieces: clockFace(P, minuteAt(t), face) });
        var n = chipCount(P);
        var sq = P.square;
        var band = function(i) {
          return R(sq.x, sq.y + sq.h - (i + 1) * sq.h / n, sq.w, sq.h / n);
        };
        f.block = K.morph(t, cue.start, FOLD, P.tray, sq);
        f.pieces = [K.piece(P.tray, "grey", 1 - OM.seg(t, cue.start, t1))].concat(chips(P).map(function(r, i) {
          return K.piece(K.morph(t, cue.start, FOLD, r, band(i), ease.cubicInOut), "blue");
        }));
        return f;
      }
      function freeze(t, cue, P) {
        var m = minuteAt(t);
        var face = K.within(K.accent(P.square, t, [cue.start + 3 * BEAT], "bottom", { sqx: 0.02, sqy: 0.03, min: K.accentMin(P) }), P.stage);
        return { block: P.square, opacity: 0, pieces: clockFace(P, m, face), copy: copy([], "frozen_time", fadeIn(t, cue.start + 0.1), K.clockTime(11 * 60 + m)) };
      }
      function sameDayLit(P, snap) {
        var v = K.values("same_day", P, snap);
        return v ? v.pctRaw : 0;
      }
      function sameDay(t, cue, P, snap) {
        var v = K.values("same_day", P, snap);
        var key = v ? "same_day" : "same_day_fallback";
        var lit = sameDayLit(P, snap);
        var beats = [1, 2, 3].map(function(k) {
          return cue.start + k * BEAT;
        });
        var sq = K.within(K.squash(P.square, t, cue.start, "bottom", STRETCH), P.stage);
        var pieces = [];
        for (var i = 0; i < 100; i++) {
          var r = K.morph(t, cue.start, 0.3, K.cell(P.square, 10, 10, i), open.shareCell(P, i, sq));
          if (i < lit) pieces.push(K.piece(open.kick(r, t, beats, open.accentPx(P)), "blue"));
          else pieces.push(K.piece(r, t >= cue.start + 0.1 ? "pale" : "blue"));
        }
        return { block: P.square, opacity: 0, pieces, copy: promise([], key, fadeIn(t, cue.start + 0.05, 0.15), v), focal: key };
      }
      var ROUTE_H = 2;
      function route(P, p) {
        var x = P.wh0.x + P.wh0.w;
        return K.piece(R(x, P.wh0.y + P.wh0.h - ROUTE_H, p * (P.shopFar.x - x), ROUTE_H), "grey");
      }
      function depart(t, cue, P, snap) {
        var t1 = cue.start + BEAT;
        var tr = P.truckL;
        var op = fadeIn(t, cue.start, K.S16);
        var ctx = [K.piece(P.wh0, "grey", op)].concat(K.storefront(P.shopFar, "grey").map(function(p) {
          p.opacity = op;
          return p;
        }));
        if (t >= t1) {
          var truck = K.morph(t, t1, cue.end - t1, tr, P.truckR, ease.expoIn);
          return { block: truck, opacity: 0, pieces: ctx.concat([route(P, ease.cubicOut(OM.seg(t, t1, t1 + BEAT))), K.piece(truck, "blue")]), copy: [] };
        }
        var lit = sameDayLit(P, snap);
        var n = lit || 100;
        var tone = lit || t >= cue.start + BEAT / 2 ? "blue" : "pale";
        var gather = function(A, B) {
          return K.morph(t, cue.start, BEAT, A, B, ease.cubicInOut);
        };
        var pieces = ctx;
        for (var i = 0; i < 100; i++) {
          var c = open.shareCell(P, i);
          pieces.push(i < n ? K.piece(gather(c, R(tr.x + i * tr.w / n, tr.y, tr.w / n, tr.h)), tone) : K.piece(c, "pale", 1 - OM.seg(t, cue.start, cue.start + BEAT / 2)));
        }
        return { block: gather(P.square, tr), opacity: 0, pieces, copy: [] };
      }
      function delivered(t, cue, P) {
        var beats = [1, 2, 3, 4, 5, 6].map(function(k) {
          return cue.start + k * BEAT;
        });
        var shopR = K.storefront(open.kick(K.squash(P.shopFar, t, cue.start, "bottom", STRETCH), t, beats, open.accentPx(P)), "blue");
        var pieces = [K.piece(P.wh0, "grey"), route(P, 1)].concat(shopR);
        if (t < cue.start + SLAM) pieces.push(K.piece(K.morph(t, cue.start, SLAM, P.truckR, shopR[0]), "blue"));
        return {
          block: K.morph(t, cue.start, SLAM, P.truckR, K.blueBox({ pieces: shopR })),
          opacity: 0,
          pieces,
          copy: promise([], "delivered", fadeIn(t, cue.start + 0.05))
        };
      }
      var CHARGE = 0.05;
      var RISE = 0.3;
      var FLIP = 0.3;
      var FULL = 0.15;
      var REACH = 0.05;
      function stepRects(P) {
        var s = P.stackBase;
        var gap = 0.04 * s.w;
        var w = (s.w - 3 * gap) / 4;
        var u = 0.78 * P.stage.h / 8;
        return [5, 6, 7, 8].map(function(n, i) {
          return R(s.x + i * (w + gap), s.y - n * u, w, n * u);
        });
      }
      function card(P) {
        var p = P.peak;
        return R(p.x, p.y + 0.15 * p.h, p.w, 0.85 * p.h);
      }
      function slab(P) {
        var st = stepRects(P);
        return R(P.stackBase.x, st[0].y, P.stackBase.w, st[0].h);
      }
      function peak(t, cue, P) {
        return {
          block: open.kick(K.morph(t, cue.start, CHARGE, P.shopFarBox, card(P), ease.expoIn), t, [cue.start + CHARGE], 0.15 * P.peak.h),
          copy: copy([], "peak_margin", 1, K.values("peak_margin", P))
        };
      }
      function tiers(t, cue, P) {
        var j = Math.max(0, K.hitIndex(t, cue.hits));
        var sl = slab(P);
        var st = stepRects(P);
        var q = sl.w / 4;
        var pieces = [];
        var land = function(r) {
          return K.squash(r, t, cue.hits[0], "bottom", STRETCH);
        };
        for (var i = 0; i <= j; i++) {
          var rise = K.morph(t, cue.hits[i], RISE, R(sl.x + i * q, sl.y, q, sl.h), st[i]);
          pieces.push(K.piece(i ? open.kick(rise, t, [cue.hits[i]], open.accentPx(P)) : land(rise), "blue"));
        }
        if (j < 3) pieces.push(K.piece(land(R(sl.x + (j + 1) * q, sl.y, (3 - j) * q, sl.h)), "blue"));
        return {
          block: K.blueBox({ pieces }),
          opacity: 0,
          pieces,
          copy: copy([], "tiers", fadeIn(t, cue.start + 0.05, 0.15))
        };
      }
      function wall(t, cue, P, snap) {
        var last = cue.hits[cue.hits.length - 1];
        var g0 = last + FULL;
        var g1 = cue.end - 0.02;
        var st = stepRects(P);
        var steps = K.blueBox({ pieces: st.map(function(r) {
          return K.piece(r, "blue");
        }) });
        var gather = function(B) {
          return K.morph(t, g0, g1 - g0, P.square, B, ease.cubicInOut);
        };
        var block = t < g0 ? K.morph(t, cue.start, FLIP, steps, P.square) : gather(shopBox(P));
        var lit = K.batch(K.hitIndex(t, cue.hits.slice(1)), cue.hits.length - 1, 9);
        var fade = 1 - OM.seg(t, g0, g1);
        var tiles = [];
        for (var i = 0; i < 9; i++) tiles.push({ id: "wall-" + (i + 1), clip: K.cell(block, 3, 3, i), opacity: i < lit ? fade : 0 });
        var f = {
          block,
          wall: { tiles },
          copy: copy([], "team", fadeIn(t, cue.start + 0.05, 0.15), K.values("team", P, snap))
        };
        if (t < cue.start + FLIP) {
          f.opacity = 0;
          f.pieces = st.map(function(r) {
            return K.piece(K.morph(t, cue.start, FLIP, r, P.square), "blue");
          });
        } else if (t <= last) {
          f.grid = { cols: 3, rows: 3, lit: 9 };
        } else if (t >= g0) {
          f.opacity = 0;
          f.pieces = shop(P).map(function(p) {
            return K.piece(gather(p), "blue");
          });
        }
        return f;
      }
      function button(t, cue, P) {
        var list = copy([], "cta", 1);
        var t1 = cue.start + REACH;
        if (t >= t1) return { block: K.squash(P.button, t, t1, "centre", STRETCH), copy: list };
        var reach = function(A) {
          return K.morph(t, cue.start, REACH, A, P.button);
        };
        return { block: reach(shopBox(P)), opacity: 0, pieces: shop(P).map(function(p) {
          return K.piece(reach(p), "blue");
        }), copy: list };
      }
      function hold(t, cue, P) {
        return { block: P.button, copy: copy([], "cta", 1) };
      }
      module.exports = {
        KINDS: {
          doors: faces(0, "warehouses"),
          hours: faces(4, "hours"),
          map,
          routes,
          ticker,
          clock,
          freeze,
          sameDay,
          depart,
          delivered,
          peak,
          tiers,
          wall,
          button,
          hold
        }
      };
    }
  });

  // lib/dealer-film/scene.js
  var require_scene = __commonJS({
    "lib/dealer-film/scene.js"(exports, module) {
      "use strict";
      var K = require_kit();
      var grid = require_grid();
      var script = require_script();
      var data = require_data();
      var open = require_kinds_open();
      var stock = require_kinds_stock();
      var reach = require_kinds_reach();
      var OM = K.OM;
      var R = K.R;
      var M = K.M;
      var bar = grid.barStart;
      var beatAt = grid.beatAt;
      var END = script.CUES.filter(function(c) {
        return c.id === "v38";
      })[0].start;
      var PIECES_MAX = 128;
      var PHOTO_IDS = ["staff-window"].concat(ids("staff-", 8), ids("wall-", 9));
      function ids(prefix, n) {
        var out = [];
        for (var i = 1; i <= n; i++) out.push(prefix + i);
        return out;
      }
      var UI_H = 40;
      var UI_BAND = M + UI_H + 12;
      var PHONE_W = 398;
      var PORTRAIT_MIN_H = 520;
      function layout(view) {
        var portrait = view.portrait === void 0 ? view.h > view.w : !!view.portrait;
        var sw = view.w - 2 * M;
        var sh = view.h - 2 * M;
        var h = view.h - UI_BAND - M;
        var stage, zone;
        if (portrait) {
          var bottom = M + Math.round(sh * 0.58);
          var w = Math.min(sw, Math.max(PHONE_W, Math.round(1.1 * (bottom - UI_BAND)), Math.round(0.75 * view.w)));
          stage = R(M + Math.round((sw - w) / 2), UI_BAND, w, bottom - UI_BAND);
          zone = R(stage.x, bottom + M, w, view.h - M - bottom - M);
        } else {
          stage = R(M, UI_BAND, Math.round(sw * 0.56), h);
          zone = R(stage.x + stage.w + M, UI_BAND, sw - stage.w - M, h);
        }
        return { portrait, view, stage, copy: zone };
      }
      function shapes(view, snap) {
        var S = layout(view).stage;
        var c = K.centred;
        var d = Math.round(Math.min(S.w, S.h) * 0.2);
        var sq = Math.min(Math.min(S.w, S.h) * 0.9, S.h / 1.17);
        var lineH = Math.max(4, Math.round(S.h * 0.012));
        var bw = S.w * 0.28;
        var btnW = Math.min(view.w - 2 * M, 360);
        var gap = S.w * 0.08;
        var hero = data.pickHeroSize(snap.rows) || snap.rows[0];
        var others = snap.rows.filter(function(r) {
          return r !== hero && data.usableRow(r);
        });
        var lg = Math.max(2, Math.round(S.h * 6e-3));
        var line = R(S.x + S.w * 0.05, S.y + S.h * 0.92 - lineH, S.w * 0.9, lineH);
        var ground = S.y + S.h * 0.7;
        var span = S.w * 0.76;
        var wh0 = R(S.x + (S.w - span) / 2, ground - d, d, d);
        var shopFar = R(wh0.x + span - Math.round(0.1 * d) - d, ground - d, d, d);
        var truck = function(r) {
          return R(r.x + 0.2 * d, ground - 0.3 * d, 0.6 * d, 0.3 * d);
        };
        return {
          view,
          stage: S,
          // Act 2's baseline on the stage bottom (right above the copy in portrait): v12's slabs, v13's
          // tower, v14's chart and act 3's stock columns (v19-v22) stand on it. A slab is `layer` tall; v13's 4x4 tower of them (16 slabs,
          // 15 gaps) is exactly the stage tall, which v13's pull-back frames.
          stackBase: { x: S.x + S.w * 0.1, y: S.y + S.h, w: S.w * 0.8 },
          layer: { h: (S.h - 15 * lg) / 16, gap: lg },
          dv: data.displayValues(snap),
          hero,
          carousel: others.length ? others : [hero],
          top: R(S.x + (S.w - d) / 2, S.y, d, d),
          // v01 drops from the stage top, under the controls
          dot: c(S, d, d),
          // v3.1's storefront at rest, where v07's bar folds into it: centred on the line, on its baseline
          // (K.storefront: its awning overhangs this by 10% a side). v08 starts from it.
          shop: R(line.x + (line.w - d) / 2, line.y + line.h - d, d, d),
          window: c(S, S.w * 0.7, S.h * 0.72),
          axis: R(S.x + S.w * 0.05, Math.round(S.y + S.h * 0.7), S.w * 0.9, 2),
          // v04's grey timeline hairline
          swarm: S,
          // v05's scatter area (kinds-open swarmLayout)
          three: c(S, S.w * 0.76, S.h * 0.4),
          // v24's push (1.25x) keeps the three windows inside the stage
          // v28's grey "one business day" tray on stackBase: a day's chips (data.ordersApprox) fill it. 0.85 of
          // the stage tall, so the iPhone SE's 140 px stage still holds 55 1 px chips (Ruling v3-23); the chute
          // (P.stage.y + 0.1 h, at most 0.06 h square) stays clear above it.
          tray: R(S.x + S.w * 0.25, S.y + S.h * 0.15, S.w * 0.5, S.h * 0.85),
          counter: c(S, S.w * 0.8, S.h * 0.26),
          square: c(S, sq, sq),
          line,
          tag: c(S, S.w * 0.8, S.h * 0.16),
          chart: { x0: S.x + (S.w - 2 * bw - gap) / 2, bw, gap, H: S.h * 0.78, base: S.y + S.h * 0.92 },
          map: c(S, S.w * 0.9, S.h * 0.8),
          wh0,
          shopFar,
          shopFarBox: K.blueBox({ pieces: K.storefront(shopFar, "blue") }),
          // the arrived storefront: v34's rest, v35's start
          truckL: truck(wh0),
          truckR: truck(shopFar),
          peak: R(M, M, view.w - 2 * M, view.h - 2 * M),
          button: R((view.w - btnW) / 2, Math.round(view.h * 0.58), btnW, 56)
        };
      }
      var KINDS = Object.assign({}, open.KINDS, stock.KINDS, reach.KINDS);
      function about(t, box, z, P) {
        var S = P.stage;
        var v = P.view;
        var fix = function(lo, hi, slo, shi) {
          return (z * (lo + hi) - slo - shi) / (2 * (z - 1));
        };
        var ax = fix(box.x, box.x + box.w, S.x, S.x + S.w);
        var ay = fix(box.y, box.y + box.h, S.y, S.y + S.h);
        return { t, x: ax - (ax - v.w / 2) / z, y: ay - (ay - v.h / 2) / z, zoom: z };
      }
      function cameraAt(t, P) {
        var v = P.view;
        var c = P.chart;
        var chart = R(c.x0, c.base - 1.02 * c.H, 2 * c.bw + c.gap, 1.02 * c.H);
        var rest = function(t2) {
          return { t: t2, x: v.w / 2, y: v.h / 2, zoom: 1 };
        };
        var lifted = function(r) {
          return R(r.x, r.y - 0.3 * r.h, r.w, 1.3 * r.h);
        };
        var push = function(b, box) {
          return [rest(bar(b)), about(bar(b) + K.BEAT / 2, lifted(box), 1.25, P), rest(bar(b + 1))];
        };
        var shop = P.shopFarBox;
        var delivery = R(P.wh0.x, shop.y, shop.x + shop.w - P.wh0.x, shop.h);
        return OM.camera(t, [
          rest(bar(2) + 0.2),
          about(beatAt(2, 3), P.window, 1.2, P),
          rest(bar(3)),
          rest(bar(9)),
          about(bar(9) + K.BEAT / 2, chart, 1.25, P),
          rest(bar(10)),
          rest(bar(12)),
          about(beatAt(12, 4), P.stage, 0.9, P),
          about(bar(13), P.stage, 0.9, P),
          rest(beatAt(13, 2))
        ].concat(push(26, P.three), push(38, delivery)), { W: v.w, H: v.h });
      }
      function fit(r, v, cam) {
        var z = cam.zoom;
        var span = function(c, half, hi) {
          var a = c - (half - M) / z;
          var b = c + (half - M) / z;
          return Math.max(a, M) < Math.min(b, hi) ? [Math.max(a, M), Math.min(b, hi)] : [a, b];
        };
        var X = span(cam.x, v.w / 2, v.w - M);
        var Y = span(cam.y, v.h / 2, v.h - M);
        var w = Math.max(1, Math.min(r.w, X[1] - X[0]));
        var h = Math.max(1, Math.min(r.h, Y[1] - Y[0]));
        return R(OM.clamp(r.x, X[0], X[1] - w), OM.clamp(r.y, Y[0], Y[1] - h), w, h);
      }
      function describe(t, view, snap) {
        t = OM.clamp(t, 0, grid.DURATION);
        var cue = script.cueAt(t);
        var P = shapes(view, snap);
        var f = KINDS[cue.kind](t, cue, P, snap);
        var cam = f.camera || cameraAt(t, P);
        var block = fit(f.block, view, cam);
        var focal = f.focal || cue.focal;
        block.opacity = f.opacity === void 0 ? 1 : f.opacity;
        var frame = {
          cue: cue.id,
          block,
          copy: f.copy.map(function(e) {
            e.focal = e.key === focal;
            return e;
          }),
          camera: { x: cam.x, y: cam.y, zoom: cam.zoom, rot: cam.rot },
          tone: t >= END ? "navy" : "canvas",
          wordmark: t >= END
        };
        ["bars", "grid", "photo", "wall", "dots", "routes", "pieces", "branches", "labels"].forEach(function(k) {
          if (f[k]) frame[k] = f[k];
        });
        return frame;
      }
      module.exports = { describe, layout, shapes, UI_H, UI_BAND, PORTRAIT_MIN_H, PHOTO_IDS, PIECES_MAX, KINDS };
    }
  });

  // lib/dealer-film/clock.js
  var require_clock = __commonJS({
    "lib/dealer-film/clock.js"(exports, module) {
      "use strict";
      var grid = require_grid();
      var DURATION = grid.DURATION;
      var STALL_MS = 250;
      var BUSY_MS = 2e3;
      function createClock(opts) {
        var audio = opts.audio;
        var now = opts.now;
        var duration = opts.duration === void 0 ? DURATION : opts.duration;
        var offset = opts.audioOffset === void 0 ? grid.AUDIO_OFFSET : opts.audioOffset;
        var state = "paused";
        var held = 0;
        var anchorT = 0;
        var anchorMs = 0;
        var soundOn = false;
        var led = false;
        var gen = 0;
        var lastA = 0;
        var lastAdvance = 0;
        var floor = 0;
        var stalled = false;
        var hidden = false;
        var wasPlaying = false;
        function clamp(t) {
          return t < 0 ? 0 : t > duration ? duration : t;
        }
        function anchor(t) {
          anchorT = t;
          anchorMs = now();
        }
        function seekAudio(t) {
          audio.currentTime = Math.max(0, t - offset);
        }
        function lead() {
          led = true;
          stalled = false;
          lastA = audio.currentTime;
          lastAdvance = now();
        }
        function giveUpSound(t) {
          soundOn = false;
          led = false;
          stalled = false;
          gen++;
          audio.muted = true;
          audio.pause();
          anchor(t);
        }
        function time() {
          if (state !== "playing") return held;
          var t;
          if (led) {
            var a = audio.currentTime;
            t = audio.ended ? duration : Math.max(clamp(a + offset), floor);
            if (a !== lastA) {
              lastA = a;
              lastAdvance = now();
            } else if (t < duration && now() - lastAdvance > (audio.seeking || audio.readyState < 3 ? BUSY_MS : STALL_MS)) {
              led = false;
              stalled = true;
              anchor(t);
            }
          } else {
            t = clamp(anchorT + (now() - anchorMs) / 1e3);
            if (stalled && !audio.seeking && audio.currentTime !== lastA && t < duration) {
              seekAudio(t);
              lead();
            }
          }
          if (t >= duration) {
            state = "ended";
            held = duration;
            led = false;
            gen++;
            audio.pause();
            return duration;
          }
          floor = t;
          return t;
        }
        function startAudio(t) {
          var mine = ++gen;
          led = false;
          stalled = false;
          seekAudio(t);
          audio.muted = false;
          var p;
          try {
            p = audio.play();
          } catch (e) {
            p = Promise.reject(e);
          }
          function ok() {
            if (mine !== gen) return;
            var pt = time();
            if (state !== "playing") return;
            seekAudio(pt);
            lead();
          }
          if (p && typeof p.then === "function") {
            p.then(ok, function() {
              if (mine === gen) giveUpSound(time());
            });
          } else {
            ok();
          }
        }
        function play() {
          if (state !== "paused") return;
          state = "playing";
          anchor(held);
          floor = held;
          if (soundOn) startAudio(held);
        }
        function pause() {
          if (state === "playing") {
            held = time();
            if (state === "playing") state = "paused";
          }
          gen++;
          led = false;
          stalled = false;
          audio.pause();
        }
        function replay() {
          held = 0;
          state = "playing";
          anchor(0);
          floor = 0;
          if (soundOn) startAudio(0);
        }
        function setSound(on) {
          if (on === soundOn) return;
          if (on) {
            soundOn = true;
            if (state === "playing") {
              startAudio(time());
            } else {
              seekAudio(held);
              audio.muted = false;
            }
          } else {
            giveUpSound(time());
          }
        }
        function onVisibility(h) {
          if (h === hidden) return;
          hidden = h;
          if (h) {
            wasPlaying = state === "playing";
            pause();
          } else if (wasPlaying) {
            wasPlaying = false;
            play();
          }
        }
        return {
          time,
          play,
          pause,
          replay,
          setSound,
          onVisibility,
          soundOn: function() {
            return soundOn;
          },
          get state() {
            return state;
          }
        };
      }
      module.exports = { createClock };
    }
  });

  // lib/dealer-film/browser.js
  var require_browser = __commonJS({
    "lib/dealer-film/browser.js"(exports, module) {
      var OM = require_onetake_motion();
      var data = require_data();
      var scene = require_scene();
      var createClock = require_clock().createClock;
      var riverSegCount = require_kinds_open().riverSegCount;
      var SVG_NS = "http://www.w3.org/2000/svg";
      var MAX_SUB = 4;
      var MAX_CELLS = 100;
      var LOOP_HOLD_MS = 4e3;
      var ROUTES = require_script().CUES.filter(function(c) {
        return c.id === "v27";
      })[0].hits.length;
      function localValues(v, lang) {
        var out = {};
        Object.keys(v).forEach(function(k) {
          var raw = v[k + "Raw"];
          if (typeof raw !== "number") out[k] = v[k];
          else if (k === "margin") out[k] = data.formatMoney(raw, lang);
          else if (k === "time") out[k] = data.formatTime(raw, lang);
          else out[k] = Math.round(raw).toLocaleString(lang === "fr" ? "fr-CA" : "en-CA");
        });
        return out;
      }
      function has(vals, token) {
        return Object.prototype.hasOwnProperty.call(vals, token.slice(1, -1));
      }
      function whSplit(tpl, vals) {
        var segs = tpl.split(" \xB7 ").filter(function(s) {
          return (s.match(/\[\w+\]/g) || []).every(function(m) {
            return has(vals, m);
          });
        });
        return data.formatCopy(segs.length ? segs.join(" \xB7 ") : tpl, vals);
      }
      function set(el, prop, val) {
        var c = el._film || (el._film = {});
        if (c[prop] !== val) el.style[prop] = c[prop] = val;
      }
      function px(n) {
        return Math.round(n * 100) / 100 + "px";
      }
      function place(el, r, m) {
        set(el, "transform", m + " translate(" + px(r.x) + "," + px(r.y) + ")");
        set(el, "width", px(r.w));
        set(el, "height", px(r.h));
      }
      function show(el, op) {
        set(el, "opacity", String(op));
      }
      function cls(el, name, on) {
        var c = el._film || (el._film = {});
        if (c["." + name] !== on) el.classList.toggle(name, c["." + name] = on);
      }
      function makeCells(g, n, doc) {
        while (g.cells.length < n) {
          var c = g.el.appendChild(doc.createElement("div"));
          for (var k = 0; k < MAX_SUB * MAX_SUB; k++) c.appendChild(doc.createElement("i"));
          g.cells.push(c);
        }
      }
      function layoutCells(g, cols, rows, doc) {
        var n = cols * rows;
        makeCells(g, n, doc);
        g.cells.forEach(function(c, i) {
          if (i >= n) return set(c, "display", "none");
          set(c, "display", "");
          set(c, "width", 100 / cols + "%");
          set(c, "height", 100 / rows + "%");
          set(c, "transform", "translate(" + i % cols * 100 + "%," + Math.floor(i / cols) * 100 + "%)");
        });
        g.shape = cols + "x" + rows;
      }
      function paintGrid(g, gr, block, m, doc) {
        show(g.el, gr ? 1 : 0);
        if (!gr) return;
        if (g.shape !== gr.cols + "x" + gr.rows) layoutCells(g, gr.cols, gr.rows, doc);
        place(g.el, block, m);
        var sub = gr.sub || 1;
        if (g.sub !== sub) {
          if (g.sub > 1) g.el.classList.remove("sub-" + g.sub);
          if (sub > 1) g.el.classList.add("sub-" + sub);
          g.sub = sub;
        }
        g.cells.forEach(function(c, i) {
          cls(c, "is-lit", i < gr.lit);
        });
      }
      function paintPieces(box, pieces, m, doc) {
        var pool = box._pool;
        if (!pool) {
          pool = box._pool = [];
          for (var i = 0; i < scene.PIECES_MAX; i++) {
            var el = box.appendChild(doc.createElement("div"));
            el.setAttribute("data-film-piece", "");
            el.style.transformOrigin = "0 0";
            pool.push(el);
          }
        }
        pool.forEach(function(el2, i2) {
          var p = pieces && pieces[i2];
          show(el2, p ? p.opacity === void 0 ? 1 : p.opacity : 0);
          if (!p) return;
          place(el2, p, m);
          if (el2._tone !== p.tone) {
            if (el2._tone) el2.classList.remove("tone-" + el2._tone);
            el2.classList.add("tone-" + p.tone);
            el2._tone = p.tone;
          }
        });
      }
      function paintDots(d, dots, m, view, doc) {
        show(d.el, dots ? 1 : 0);
        if (!dots) return;
        set(d.el, "transform", m);
        var key = view.w + "x" + view.h;
        if (d.key !== key) {
          while (d.items.length < dots.pts.length) d.items.push(d.el.appendChild(doc.createElement("div")));
          dots.pts.forEach(function(p, i) {
            set(d.items[i], "transform", "translate(" + px(p.x) + "," + px(p.y) + ")");
          });
          d.key = key;
        }
        d.items.forEach(function(el, i) {
          cls(el, "is-lit", i < dots.lit);
        });
      }
      function attr(el, name, val) {
        var c = el._film || (el._film = {});
        if (c["@" + name] !== val) el.setAttribute(name, c["@" + name] = val);
      }
      function round2(n) {
        return String(Math.round(n * 100) / 100);
      }
      function makeLine(r, doc, marker, tag, into) {
        var l = (into || r.el).appendChild(doc.createElementNS(SVG_NS, tag || "line"));
        l.setAttribute("pathLength", "1");
        if (marker) l.setAttribute("marker-end", "url(#" + marker + ")");
        l.style.strokeDasharray = "1";
        r.lines.push(l);
      }
      var TIP = 3;
      function makeTips(b, doc) {
        var defs = b.el.appendChild(doc.createElementNS(SVG_NS, "defs"));
        ["blue", "grey"].forEach(function(tone) {
          var m = defs.appendChild(doc.createElementNS(SVG_NS, "marker"));
          [
            ["id", "tt-film-tip-" + tone],
            ["markerUnits", "userSpaceOnUse"],
            ["markerWidth", TIP],
            ["markerHeight", TIP],
            ["viewBox", "0 0 " + TIP + " " + TIP],
            ["refX", TIP / 2],
            ["refY", TIP / 2]
          ].forEach(function(a) {
            m.setAttribute(a[0], String(a[1]));
          });
          var r = m.appendChild(doc.createElementNS(SVG_NS, "rect"));
          r.setAttribute("width", String(TIP));
          r.setAttribute("height", String(TIP));
        });
        b.tips = defs;
      }
      function prime(nodes, snap) {
        var sizes = data.riverSizes(snap);
        if (nodes.branches) {
          var b = nodes.branches;
          if (!b.tips) makeTips(b, nodes.doc);
          if (!b.g) b.g = b.el.appendChild(nodes.doc.createElementNS(SVG_NS, "g"));
          while (b.lines.length < riverSegCount(sizes.length)) makeLine(b, nodes.doc, "tt-film-tip-blue", "polyline", b.g);
        }
        if (nodes.labels) {
          while (nodes.labels.items.length < sizes.length) {
            var span = nodes.labels.el.appendChild(nodes.doc.createElement("span"));
            span.textContent = sizes[nodes.labels.items.length];
            nodes.labels.items.push(span);
          }
        }
        if (nodes.grid) makeCells(nodes.grid, MAX_CELLS, nodes.doc);
        if (nodes.dots) {
          var n = data.displayValues(snap).fsaApprox;
          while (nodes.dots.items.length < n) nodes.dots.items.push(nodes.dots.el.appendChild(nodes.doc.createElement("div")));
        }
        if (nodes.routes) while (nodes.routes.lines.length < ROUTES) makeLine(nodes.routes, nodes.doc);
      }
      function paintRoutes(r, routes, m, view, doc) {
        show(r.el, routes ? 1 : 0);
        if (!routes) return;
        set(r.el, "transform", m);
        var key = view.w + "x" + view.h;
        if (r.key !== key) {
          r.el.setAttribute("viewBox", "0 0 " + view.w + " " + view.h);
          while (r.lines.length < routes.length) makeLine(r, doc);
          routes.forEach(function(rt, i) {
            ["x1", "y1", "x2", "y2"].forEach(function(a) {
              r.lines[i].setAttribute(a, String(Math.round(rt[a] * 100) / 100));
            });
          });
          r.key = key;
        }
        routes.forEach(function(rt, i) {
          set(r.lines[i], "strokeDashoffset", String(Math.round((1 - rt.p) * 1e3) / 1e3));
        });
      }
      function setVar(el, name, val) {
        var c = el._film || (el._film = {});
        if (c[name] !== val) el.style.setProperty(name, c[name] = val);
      }
      function paintBranches(b, branches, M, view) {
        show(b.el, branches ? 1 : 0);
        if (!branches) return;
        attr(b.el, "viewBox", "0 0 " + view.w + " " + view.h);
        if (b.g) attr(b.g, "transform", "matrix(" + M.join(",") + ")");
        setVar(b.el, "--tt-zoom", String(Math.round(Math.hypot(M[0], M[1]) * 1e4) / 1e4));
        b.lines.forEach(function(l, i) {
          var br = branches[i];
          show(l, br ? 1 : 0);
          if (!br) return;
          if (l._pts !== br.pts) {
            l._pts = br.pts;
            attr(l, "points", br.pts.map(function(q) {
              return round2(q.x) + "," + round2(q.y);
            }).join(" "));
          }
          setVar(l, "--w", br.w + "px");
          set(l, "strokeDashoffset", String(Math.round((1 - br.p) * 1e3) / 1e3));
          cls(l, "tone-grey", br.tone === "grey");
          attr(l, "marker-end", !br.dot || br.p < 1 ? "none" : "url(#tt-film-tip-" + (br.tone === "grey" ? "grey" : "blue") + ")");
        });
      }
      function paintLabels(lb, labels, M) {
        show(lb.el, labels ? 1 : 0);
        if (!labels) return;
        var on = {};
        labels.forEach(function(l) {
          on[l.i] = l;
        });
        lb.items.forEach(function(el, i) {
          var l = on[i];
          show(el, l ? l.opacity : 0);
          if (!l) return;
          set(el, "transform", "translate(" + px(M[0] * l.x + M[2] * l.y + M[4]) + "," + px(M[1] * l.x + M[3] * l.y + M[5]) + ")" + (l.right ? " translateX(-100%)" : ""));
          cls(el, "is-hot", !!l.hot);
        });
      }
      function same(a, b) {
        return Math.abs(a.x - b.x) < 0.5 && Math.abs(a.y - b.y) < 0.5 && Math.abs(a.w - b.w) < 0.5 && Math.abs(a.h - b.h) < 0.5;
      }
      function paint(f, nodes, view) {
        var root = nodes.root;
        var M = OM.view(f.camera, { W: view.w, H: view.h });
        var m = "matrix(" + M.join(",") + ")";
        cls(root, "tone-canvas", f.tone === "canvas");
        cls(root, "tone-navy", f.tone === "navy");
        cls(root, "is-portrait", scene.layout(view).portrait);
        if (nodes.cue !== f.cue) {
          if (nodes.cue) root.classList.remove("cue-" + nodes.cue);
          root.classList.add("cue-" + f.cue);
          nodes.cue = f.cue;
        }
        if (nodes.block) {
          place(nodes.block, f.block, m);
          show(nodes.block, f.block.opacity);
        }
        if (nodes.bars) {
          show(nodes.bars, f.bars ? 1 : 0);
          if (f.bars) {
            if (nodes.ct) place(nodes.ct, f.bars.ct, m);
            if (nodes.dealer) {
              var free = !same(f.bars.dealer, f.block);
              cls(nodes.dealer, "tone-grey", !!f.bars.tone && f.bars.tone.dealer === "grey");
              show(nodes.dealer, free ? 1 : 0);
              if (free) place(nodes.dealer, f.bars.dealer, m);
            }
          }
        }
        if (nodes.pieces) paintPieces(nodes.pieces, f.pieces, m, nodes.doc);
        if (nodes.grid) paintGrid(nodes.grid, f.grid, f.block, m, nodes.doc);
        if (nodes.dots) paintDots(nodes.dots, f.dots, m, view, nodes.doc);
        if (nodes.routes) paintRoutes(nodes.routes, f.routes, m, view, nodes.doc);
        if (nodes.branches) paintBranches(nodes.branches, f.branches, M, view);
        if (nodes.labels) paintLabels(nodes.labels, f.labels, M);
        var shown = {};
        if (f.photo) shown[f.photo.id] = f.photo;
        if (f.wall) f.wall.tiles.forEach(function(tile) {
          shown[tile.id] = tile;
        });
        Object.keys(nodes.photos).forEach(function(id) {
          var p = shown[id];
          if (p) place(nodes.photos[id], p.clip, m);
          show(nodes.photos[id], p ? p.opacity : 0);
        });
        if (nodes.wall) show(nodes.wall, f.wall ? 1 : 0);
        if (nodes.wordmark) show(nodes.wordmark, f.wordmark ? 1 : 0);
        var on = {};
        f.copy.forEach(function(e) {
          on[e.key] = e;
        });
        nodes.copy.forEach(function(c) {
          var e = on[c.key];
          show(c.el, e ? e.opacity : 0);
          cls(c.el, "is-on", !!e);
          cls(c.el, "is-focal", !!(e && e.focal));
          if (e && e.values) {
            var vals = localValues(e.values, nodes.lang);
            var text = c.key === "wh_split" ? whSplit(c.tpl, vals) : data.formatCopy(c.tpl, vals);
            if (c.text !== text) c.el.textContent = c.text = text;
          }
        });
      }
      function collect(doc, root, lang) {
        var q = function(s) {
          return root.querySelector(s);
        };
        var photos = {};
        Array.prototype.forEach.call(root.querySelectorAll("[data-film-photo]"), function(el) {
          photos[el.getAttribute("data-film-photo")] = el;
        });
        var gridEl = q("[data-film-grid]");
        var dotsEl = q("[data-film-dots]");
        var routesEl = q("[data-film-routes]");
        var branchesEl = q("[data-film-branches]");
        var labelsEl = q("[data-film-labels]");
        var nodes = {
          doc,
          root,
          lang,
          block: q("[data-film-block]"),
          bars: q("[data-film-bars]"),
          ct: q('[data-film-bar="ct"]'),
          dealer: q('[data-film-bar="dealer"]'),
          pieces: q("[data-film-pieces]"),
          grid: gridEl && { el: gridEl, cells: [], shape: "", sub: 1 },
          dots: dotsEl && { el: dotsEl, items: [], key: "" },
          routes: routesEl && { el: routesEl, lines: [], key: "" },
          branches: branchesEl && { el: branchesEl, lines: [] },
          labels: labelsEl && { el: labelsEl, items: [] },
          photos,
          wall: q("[data-film-wall]"),
          wordmark: q("[data-film-wordmark]"),
          copy: Array.prototype.map.call(root.querySelectorAll("[data-film-cue-key]"), function(el) {
            return { el, key: el.getAttribute("data-film-cue-key"), tpl: el.textContent };
          })
        };
        if (nodes.ct) nodes.ct.classList.add("bar-ct");
        if (nodes.dealer) nodes.dealer.classList.add("bar-dealer");
        [nodes.block, nodes.ct, nodes.dealer, gridEl, dotsEl, routesEl].concat(Object.keys(photos).map(function(id) {
          return photos[id];
        })).forEach(function(el) {
          if (el) el.style.transformOrigin = "0 0";
        });
        return nodes;
      }
      function clipInset(view) {
        var st = scene.layout(view).stage;
        return { t: st.y, r: view.w - st.x - st.w, b: view.h - st.y - st.h, l: st.x };
      }
      function filmOffset(top, innerHeight) {
        return top < innerHeight / 2 ? Math.round(top) : 0;
      }
      function readSnapshot(doc) {
        var node = doc.querySelector("[data-dealer-film-data]");
        if (!node) return null;
        try {
          var snap = JSON.parse(node.textContent);
          return data.validateSnapshot(snap).length ? null : snap;
        } catch (e) {
          return null;
        }
      }
      function boot(doc, win) {
        var root = doc.querySelector("[data-dealer-film]");
        var dead = false;
        var raf = 0;
        var soundAuto = false;
        var chose = false;
        var hero = false;
        var loop = false;
        var offscreen = false;
        var loopTimer = 0;
        var loopPending = false;
        var clock, nodes, snap, view, last;
        function refuse(reason) {
          if (root) root.classList.add("is-static");
          return { ok: false, reason };
        }
        function fail(e) {
          if (dead) return;
          dead = true;
          if (raf) win.cancelAnimationFrame(raf);
          raf = 0;
          if (root) {
            root.classList.add("is-static");
            root.classList.remove("is-playing");
          }
          try {
            if (clock) clock.pause();
          } catch (ignore) {
          }
          console.warn("[dealer-film] stopped:", e);
        }
        function guard(fn) {
          return function() {
            if (dead) return;
            try {
              fn.apply(this, arguments);
            } catch (e) {
              fail(e);
            }
          };
        }
        function label(btn, attr2) {
          if (!btn) return;
          var text = btn.getAttribute(attr2);
          if (text != null && btn.textContent !== text) {
            btn.textContent = text;
            btn.setAttribute("aria-label", text);
          }
        }
        function syncControls() {
          var playing = clock.state === "playing";
          var sound = clock.soundOn();
          label(nodes.sound, sound ? "data-label-on" : "data-label-off");
          if (nodes.sound) cls(nodes.sound, "is-nudge", soundAuto && !chose && !sound);
          label(nodes.pause, playing ? "data-label-pause" : "data-label-play");
          if (nodes.replay) nodes.replay.hidden = clock.state !== "ended";
        }
        function draw(t) {
          last = scene.describe(t, view, snap);
          paint(last, nodes, view);
          syncControls();
        }
        function away() {
          return !!doc.hidden || offscreen;
        }
        function replayNow() {
          loopPending = false;
          clock.replay();
          syncControls();
          run();
        }
        function armLoop() {
          if (!loop || loopTimer || clock.state !== "ended") return;
          loopTimer = win.setTimeout(guard(function() {
            loopTimer = 0;
            if (clock.state !== "ended") return;
            if (away()) loopPending = true;
            else replayNow();
          }), LOOP_HOLD_MS);
        }
        function visibilityChanged() {
          clock.onVisibility(away());
          if (!away() && loopPending && clock.state === "ended") replayNow();
          syncControls();
          run();
        }
        var tick = guard(function() {
          raf = 0;
          draw(clock.time());
          armLoop();
          run();
        });
        function run() {
          if (!raf && !dead && clock.state === "playing") raf = win.requestAnimationFrame(tick);
        }
        function measure() {
          var top = root.getBoundingClientRect().top + (win.scrollY || 0);
          root.style.setProperty("--tt-film-offset", filmOffset(top, win.innerHeight) + "px");
          var portrait = win.innerWidth && win.innerHeight ? win.innerHeight >= win.innerWidth : null;
          if (hero && root.clientWidth && root.clientHeight) portrait = root.clientHeight > root.clientWidth;
          if (portrait !== null) cls(root, "is-portrait", portrait);
          var v = { w: root.clientWidth || win.innerWidth, h: root.clientHeight || win.innerHeight };
          if (portrait !== null) v.portrait = portrait;
          if (scene.layout(v).portrait) v.h = Math.max(v.h, scene.PORTRAIT_MIN_H);
          var copy = scene.layout(v).copy;
          root.style.setProperty("--tt-copy-x", copy.x + "px");
          root.style.setProperty("--tt-copy-r", v.w - copy.x - copy.w + "px");
          var c = clipInset(v);
          ["t", "r", "b", "l"].forEach(function(k) {
            root.style.setProperty("--tt-clip-" + k, c[k] + "px");
          });
          return v;
        }
        try {
          if (win.matchMedia && win.matchMedia("(prefers-reduced-motion: reduce)").matches) return refuse("reduced-motion");
          var conn = win.navigator && win.navigator.connection;
          if (conn && conn.saveData) return refuse("save-data");
          snap = readSnapshot(doc);
          if (!snap) return refuse("data");
          if (!root) return refuse("no-root");
          var lang = root.getAttribute("data-lang") || (doc.documentElement && doc.documentElement.lang || "").slice(0, 2);
          nodes = collect(doc, root, lang === "fr" ? "fr" : "en");
          soundAuto = root.getAttribute("data-sound") === "auto";
          hero = root.getAttribute("data-variant") === "hero";
          loop = root.getAttribute("data-loop") !== null;
          nodes.sound = root.querySelector("[data-film-sound]");
          nodes.pause = root.querySelector("[data-film-pause]");
          nodes.replay = root.querySelector("[data-film-replay]");
          prime(nodes, snap);
          view = measure();
          var audio = doc.createElement("audio");
          audio.preload = hero && !soundAuto ? "none" : "auto";
          audio.muted = true;
          audio.src = root.getAttribute("data-audio-src") || "";
          clock = createClock({ audio, now: function() {
            return win.performance.now();
          } });
          if (nodes.sound) nodes.sound.addEventListener("click", guard(function() {
            chose = true;
            clock.setSound(!clock.soundOn());
            syncControls();
          }));
          if (soundAuto) root.addEventListener("click", guard(function(e) {
            if (chose || clock.soundOn()) return;
            var t = e && e.target;
            if (t && t.closest && t.closest("[data-film-sound],[data-film-pause],[data-film-replay],a,button")) return;
            clock.setSound(true);
            syncControls();
          }));
          if (nodes.pause) nodes.pause.addEventListener("click", guard(function() {
            if (clock.state === "playing") clock.pause();
            else if (clock.state === "ended") clock.replay();
            else clock.play();
            syncControls();
            run();
          }));
          if (nodes.replay) nodes.replay.addEventListener("click", guard(function() {
            loopPending = false;
            clock.replay();
            syncControls();
            run();
          }));
          doc.addEventListener("visibilitychange", guard(visibilityChanged));
          if (hero && win.IntersectionObserver) {
            var watcher = new win.IntersectionObserver(guard(function(entries) {
              var off = !entries[entries.length - 1].isIntersecting;
              if (off === offscreen) return;
              offscreen = off;
              visibilityChanged();
            }));
            watcher.observe(root);
          }
          win.addEventListener("resize", guard(function() {
            view = measure();
            if (!raf) draw(clock.time());
          }));
          if (/[?&]film_debug=1(&|$)/.test(win.location && win.location.search || "")) {
            win.__dealerFilm = {
              seek: guard(function(t) {
                clock.pause();
                if (raf) win.cancelAnimationFrame(raf);
                raf = 0;
                draw(t);
              }),
              frame: function() {
                return last;
              }
            };
          }
          root.classList.add("is-playing");
          if (soundAuto) clock.setSound(true);
          clock.play();
          clock.onVisibility(away());
          draw(clock.time());
          run();
        } catch (e) {
          fail(e);
        }
        return dead ? { ok: false, reason: "error" } : { ok: true };
      }
      if (typeof window !== "undefined" && typeof document !== "undefined") {
        if (document.readyState === "loading") {
          document.addEventListener("DOMContentLoaded", function() {
            boot(document, window);
          });
        } else {
          boot(document, window);
        }
      }
      module.exports = { boot, paint, paintPieces, filmOffset, clipInset };
    }
  });
  require_browser();
})();
